module.exports = Object.freeze({
  COMMON_DEVELOPER_PORTAL: 'Developer Portal',
  COMMON_METADATA_TITLE_PREFIX: 'Discord Developer Portal',
  COMMON_CLOSE: 'Close',
  COMMON_SAVE: 'Save',
  COMMON_ADD: 'Add',
  COMMON_SUBMIT: 'Submit',
  COMMON_NO: 'No',
  COMMON_NOT_AVAILABLE: 'N/A',
  COMMON_COPY_TO_CLIPBOARD: 'Copy to Clipboard',
  COMMON_LOGGED_IN_HEADER: 'Logged in as',
  COMMON_SETTINGS_NOTICE_MESSAGE: 'Careful — you have unsaved changes!',
  COMMON_APPLICATION_NOT_FOUND_HEADING: 'Application not found!',
  COMMON_APPLICATION_NOT_FOUND_BODY: 'There was no application found with ID **!!{appId}!!**.',
  COMMON_SKU_NOT_FOUND_HEADING: 'SKU not found!',
  COMMON_SKU_NOT_FOUND_BODY: 'There was no SKU found with ID **!!{skuId}!!**.',
  COMMON_ROUTE_NOT_FOUND_HEADING: 'Route not found!',
  COMMON_ROUTE_NOT_FOUND_BODY: 'The route specified was not found.',
  COMMON_TEAM_NOT_FOUND_HEADING: 'Team not found!',
  COMMON_TEAM_NOT_FOUND_BODY: 'There was no Team found with ID **!!{teamId}!!**',
  COMMON_GENERIC_API_ERROR: `Oops! You've caught an ultra rare error. This is probably our fault, so please try again or check [our status page]({statusPageURL}).`,
  COMMON_RATE_LIMIT_ERROR: `You are being rate limited. Chill out for a bit before attempting your request again.`,
  COMMON_INVALID_MFA_CODE: 'Invalid 2FA code provided.',
  COMMON_NEW: 'New',
  COMMON_DESCRIPTION: 'Description',
  COMMON_TOKEN_GENERATE_SUCCESS: 'A new token was generated! Be sure to copy it as it will not be shown to you again.',
  COMMON_TWO_FACTOR_AUTHENTICATION_REQUIRED: 'Two-factor authentication is required for this operation.',
  COMMON_PAGINATOR_OF_PAGES: 'Page !!{currentPage, number}!! of !!{numPages, number}!!',
  COMMON_SORT_BY: 'Sort By:',
  COMMON_SMALL: 'Small',
  COMMON_LARGE: 'Large',
  COMMON_A_THROUGH_Z: 'A–Z',
  COMMON_DATE_CREATED: 'Date Created',
  COMMON_APPLICATION_VERIFICATION_DISABLED_HOLIDAY_BREAK:
    'The verification form is currently closed for the holidays. We have increased the maximum guild limit for bots to 250 until the form re-opens. The form will re-open on January 11, 2021.',
  COMMON_APPLICATION_VERIFICATION_INVALID_PRIVACY_POLICY_EMPTY:
    'All apps must have a privacy policy. Add one [here]({appInfoLink}).',
  COMMON_APPLICATION_VERIFICATION_INVALID_TOS_EMPTY:
    'All apps must have a Terms of Service. Add one [here]({appInfoLink}).',
  COMMON_SELECT: 'Select',
  COMMON_TOGGLE_MENU: 'Toggle Menu',
  COMMON_USER_MENU: 'User Menu',
  COMMON_DOWNLOAD: 'Download',

  // TODO(beckwith) Previously undiscovered string references found during TypeScript migration.
  COMMON_NO_RESULTS_FOUND: 'No results found',
  COMMON_GAME_FEED_USER_PLAYING_JUST_STARTED: 'GAME_FEED_USER_PLAYING_JUST_STARTED placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYING_FOR_MINUTES: 'GAME_FEED_USER_PLAYING_FOR_MINUTES placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYING_FOR_HOURS: 'GAME_FEED_USER_PLAYING_FOR_HOURS placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYING_FOR_DAYS: 'GAME_FEED_USER_PLAYING_FOR_DAYS placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYING_JUST_ENDED: 'GAME_FEED_USER_PLAYING_JUST_ENDED placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYED_MINUTES_AGO: 'GAME_FEED_USER_PLAYED_MINUTES_AGO placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYED_HOURS_AGO: 'GAME_FEED_USER_PLAYED_HOURS_AGO placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYED_DAYS_AGO: 'GAME_FEED_USER_PLAYED_DAYS_AGO placeholder {time}',
  COMMON_GAME_FEED_USER_PLAYING_JUST_STARTED: 'GAME_FEED_USER_PLAYING_JUST_STARTED placeholder {time}',
  COMMON_USER_ACTIVITY_USER_PLAYING_FOR_MINUTES: 'USER_ACTIVITY_USER_PLAYING_FOR_MINUTES placeholder {time}',
  COMMON_USER_ACTIVITY_USER_PLAYING_FOR_HOURS: 'USER_ACTIVITY_USER_PLAYING_FOR_HOURS placeholder {time}',
  COMMON_USER_ACTIVITY_USER_PLAYING_FOR_DAYS: 'USER_ACTIVITY_USER_PLAYING_FOR_DAYS placeholder {time}',

  COMMON_LOGO_ALT_TEXT: 'Return to discord.dev',

  APP_NAVIGATION_APPLICATIONS: 'Applications',
  APP_NAVIGATION_TEAMS: 'Teams',
  APP_NAVIGATION_DOCUMENTATION: 'Documentation',
  APP_NAVIGATION_GUILDS: 'Server Insights',
  APP_NAVIGATION_EMBED_DEBUGGER: 'Embed Debugger',

  ERROR_PAGE_ERROR_DESCRIPTION: `That's so 1939. Discord is secretly powered by quantum robot hamsters. Technology is wild, isn't it? Anyway, you look lost. Here are a few suggested pages.`,
  ERROR_PAGE_ERROR_HEADER: 'Wizards Behind Curtains?',
  ERROR_PAGE_STATUS_PAGE_LINK: 'Status Page',
  ERROR_PAGE_SUPPORT_LINK: 'Help and Support',
  ERROR_PAGE_DOCUMENTATION_LINK: 'API Documentation',

  FORMS_USERNAME: 'Username',
  FORMS_DISCRIMINATOR: 'Discriminator',
  FORMS_REQUIRED_FIELD: 'This field is required.',
  FORMS_NAME: 'Name',
  FORMS_ICON: 'Icon',

  DEVELOPER_PAGES_PAGE_TITLE: 'Documentation',

  // Confirm Modal
  DEVELOPER_PAGES_DEFAULT_CONFIRM_TITLE: 'Confirmation Required',
  DEVELOPER_PAGES_DEFAULT_CONFIRM_MSG: 'Please confirm you want to take this action.',
  DEVELOPER_PAGES_CANCEL_BUTTON: 'Nevermind',
  DEVELOPER_PAGES_CONFIRM_BUTTON: 'Yes, do it!',

  // New App/Edit App
  DEVELOPER_PAGES_ERROR_HEADING: 'Error encountered!',
  DEVELOPER_PAGES_ERROR_UNKNOWN: 'Unknown Error',

  // Developer Tools
  DEVELOPER_PAGES_PERMISSIONS_CALCULATOR: 'Permissions Calculator',
  DEVELOPER_PAGES_PERMISSIONS_CALCULATOR_PERMISSIONS_INTEGER: 'Permissions Integer',
  DEVELOPER_PAGES_MISSING_CLIENT_ID: 'Please enter a client id',
  DEVELOPER_PAGES_MISSING_REDIRECT_URI: 'Please enter a redirect uri',
  DEVELOPER_PAGES_TOO_FEW_SCOPES: 'Please select at least one OAuth2 scope',

  AVATAR_UPLOADER_SELECT_IMAGE: 'Select\nImage',
  AVATAR_UPLOADER_REMOVE: 'Remove',
  AVATAR_UPLOADER_MINIMUM_SIZE: 'Minimum Size: **{size}x{size}**',
  AVATAR_UPLOADER_SIZE: 'Size: **{size}x{size}**',
  AVATAR_UPLOADER_DIMENSIONS: 'Size: **{width}x{height}**',
  AVATAR_UPLOADER_IMAGES: 'Images',

  // General Permissions
  PERMISSIONS_GENERAL_PERMISSIONS: 'General Permissions',
  PERMISSIONS_ADMINISTRATOR: 'Administrator',
  PERMISSIONS_VIEW_AUDIT_LOG: 'View Audit Log',
  PERMISSIONS_MANAGE_SERVER: 'Manage Server',
  PERMISSIONS_MANAGE_ROLES: 'Manage Roles',
  PERMISSIONS_MANAGE_CHANNELS: 'Manage Channels',
  PERMISSIONS_KICK_MEMBERS: 'Kick Members',
  PERMISSIONS_BAN_MEMBERS: 'Ban Members',
  PERMISSIONS_CREATE_INSTANT_INVITE: 'Create Instant Invite',
  PERMISSIONS_CHANGE_NICKNAME: 'Change Nickname',
  PERMISSIONS_MANAGE_NICKNAMES: 'Manage Nicknames',
  PERMISSIONS_MANAGE_EMOJIS_AND_STICKERS: 'Manage Emojis and Stickers',
  PERMISSIONS_CREATE_EMOJIS_AND_STICKERS: 'Create Emojis and Stickers',
  PERMISSIONS_MANAGE_WEBHOOKS: 'Manage Webhooks',
  PERMISSIONS_CREATE_EXPRESSIONS: 'Create Expressions',
  PERMISSIONS_MANAGE_EXPRESSIONS: 'Manage Expressions',
  PERMISSIONS_VIEW_CHANNELS: 'View Channels',
  PERMISSIONS_MANAGE_EVENTS: 'Manage Events',
  PERMISSIONS_CREATE_EVENTS: 'Create Events',
  PERMISSIONS_MODERATE_MEMBERS: 'Moderate Members',
  PERMISSIONS_VIEW_GUILD_ANALYTICS: 'View Server Insights',
  PERMISSIONS_VIEW_CREATOR_MONETIZATION_ANALYTICS: 'View Server Subscription Insights',

  // Text Permissions
  PERMISSIONS_TEXT_PERMISSIONS: 'Text Permissions',
  PERMISSIONS_SEND_MESSAGES: 'Send Messages',
  PERMISSIONS_SEND_TTS_MESSAGES: 'Send TTS Messages',
  PERMISSIONS_MANAGE_MESSAGES: 'Manage Messages',
  PERMISSIONS_EMBED_LINKS: 'Embed Links',
  PERMISSIONS_ATTACH_FILES: 'Attach Files',
  PERMISSIONS_READ_MESSAGE_HISTORY: 'Read Message History',
  PERMISSIONS_MENTION_EVERYONE: 'Mention Everyone',
  PERMISSIONS_USE_EXTERNAL_EMOJIS: 'Use External Emojis',
  PERMISSIONS_USE_EXTERNAL_STICKERS: 'Use External Stickers',
  PERMISSIONS_ADD_REACTIONS: 'Add Reactions',
  PERMISSIONS_USE_APPLICATION_COMMANDS: 'Use Slash Commands',
  PERMISSIONS_MANAGE_THREADS: 'Manage Threads',
  PERMISSIONS_CREATE_PUBLIC_THREADS: 'Create Public Threads',
  PERMISSIONS_CREATE_PRIVATE_THREADS: 'Create Private Threads',
  PERMISSIONS_SEND_MESSAGES_IN_THREADS: 'Send Messages in Threads',
  PERMISSIONS_SEND_POLLS: 'Create Polls',
  PERMISSIONS_USE_EXTERNAL_APPS: 'Use External Apps',

  // Voice Permissions
  PERMISSIONS_VOICE_PERMISSIONS: 'Voice Permissions',
  PERMISSIONS_CONNECT: 'Connect',
  PERMISSIONS_SPEAK: 'Speak',
  PERMISSIONS_VIDEO: 'Video',
  PERMISSIONS_MUTE_MEMBERS: 'Mute Members',
  PERMISSIONS_DEAFEN_MEMBERS: 'Deafen Members',
  PERMISSIONS_MOVE_MEMBERS: 'Move Members',
  PERMISSIONS_USE_VAD: 'Use Voice Activity',
  PERMISSIONS_PRIORITY_SPEAKER: 'Priority Speaker',
  PERMISSIONS_STREAM: 'Stream',
  PERMISSIONS_REQUEST_TO_SPEAK: 'Request To Speak',
  PERMISSIONS_USE_EMBEDDED_ACTIVITIES: 'Use Embedded Activities',
  PERMISSIONS_USE_SOUNDBOARD: 'Use Soundboard',
  PERMISSIONS_USE_EXTERNAL_SOUNDS: 'Use External Sounds',

  DEVELOPERS_METADATA_TITLE: 'API Docs',
  DEVELOPERS_METADATA_OGTITLE: 'Discord API Docs for Bots and Developers',
  DEVELOPERS_METADATA_DESCRIPTION: `Integrate your service with Discord — whether it's a bot or a game or whatever your wildest imagination can come up with.`,
  DEVELOPERS_BREAKING_CHANGE: 'This entry includes breaking changes',
  DEVELOPERS_FILTER_BY: 'Filter By:',

  WHITELIST_HEADING: 'Application Testers',
  WHITELIST_SUBHEADING:
    'You can invite up to 50 Discord users to test your application. They must have a registered email and a positive attitude :^)',
  WHITELIST_INVITED_TESTERS_HEADING: 'Invited Testers ({count, number} of 50)',
  WHITELIST_PENDING_INVITE: 'Pending Invite',
  WHITELIST_ACCEPTED_INVITE: 'Accepted',
  WHITELIST_INVITE: 'Invite',
  WHITELIST_NO_USERS_INVITED: 'No users invited',

  DISCOVERY_SETTINGS_HEADING: 'Discovery Settings',
  DISCOVERY_SETTINGS_SUBHEADING: `Configure how your application is displayed on Discord's discovery surfaces.`,
  DISCOVERY_SETTINGS_SUBHEADING_LINK: '[Read our App Directory best practices]({link})',
  DISCOVERY_SETTINGS_EXTERNAL_LINKS: 'Links',
  DISCOVERY_SETTINGS_EXTERNAL_LINKS_ADD_BUTTON_TEXT: 'Add',
  DISCOVERY_SETTINGS_EXTERNAL_LINKS_DESCRIPTION:
    'Share your website, GitHub, or other links relevant to your app. You can include up to five links.',
  DISCOVERY_SETTINGS_EXTERNAL_LINKS_ITEM_NAME: 'External Link Name',
  DISCOVERY_SETTINGS_EXTERNAL_LINKS_ITEM_URL: 'External Link URL',
  DISCOVERY_SETTINGS_ENTRY_FETCH_FAILED: 'There was an error fetching the app discoverability entry.',
  DISCOVERY_SETTINGS_ENTRY_SAVE_FAILED: 'There was an error saving the app discoverability entry.',
  DISCOVERY_SETTINGS_LOCALIZED_DETAILED_DESCRIPTIONS: 'Expanded Description',
  DISCOVERY_SETTINGS_LOCALIZED_SHORT_DESCRIPTIONS: 'Summary',
  DISCOVERY_SETTINGS_LOCALIZED_DETAILED_DESCRIPTIONS_DESCRIPTION:
    'If you have more you would like to tell people about your app, do so below. Tell us about your app, and translate it to other languages. This field supports markdown.',
  DISCOVERY_SETTINGS_LOCALIZED_SHORT_DESCRIPTIONS_DESCRIPTION:
    'Give us a short summary of your app. This will appear in search and on your profile page.',
  DISCOVERY_SETTINGS_LOCALIZED_DESCRIPTIONS_EMPTY: `You need to select your app's supported languages before entering a description.`,
  DISCOVERY_SETTINGS_LOCALIZED_DESCRIPTIONS_EDITOR_EDIT: 'Edit Description',
  DISCOVERY_SETTINGS_LOCALIZED_DESCRIPTIONS_EDITOR_PREVIEW: 'Preview',
  DISCOVERY_SETTINGS_CAROUSEL_ITEMS: 'Media',
  DISCOVERY_SETTINGS_CAROUSEL_ITEMS_ADD_BUTTON_TEXT: 'Add',
  DISCOVERY_SETTINGS_CAROUSEL_ITEMS_DESCRIPTION: `Include screenshots and videos to show what makes your app unique.`,
  DISCOVERY_SETTINGS_CAROUSEL_ITEMS_SUPPORTED_LINKS: `Supported links: YouTube videos, .png, .jpeg, .gif, .webp`,
  DISCOVERY_SETTINGS_SUPPORT_SERVER: 'Support Server',
  DISCOVERY_SETTINGS_SUPPORT_SERVER_DESCRIPTION:
    'This server lets people contact you for support and join your community. It must be a [Community Server]({link}).',
  DISCOVERY_SETTINGS_SUPPORT_SERVER_SELECTED_DETAILS:
    'The selected support server ({guildId}) cannot be found by your user. **Do not select a server unless you intend to use a different server**.',
  DISCOVERY_SETTINGS_SUPPORT_SERVER_UNKNOWN: 'Selected Support Server: Guild ID "{guildId}"',
  DISCOVERY_SETTINGS_SUPPORTED_LOCALES: 'Languages',
  DISCOVERY_SETTINGS_SUPPORTED_LOCALES_DESCRIPTION: `Create a list of languages your app supports.`,
  DISCOVERY_SETTINGS_APP_DIRECTORY_PREVIEW: 'Preview App Directory',
  DISCOVERY_SETTINGS_SUPPORT_SERVER_REQUIRED: 'A support server is required.',

  DISCOVERY_STATUS_LOAD_ERROR: 'We were unable to load your application. Please try again later',
  DISCOVERY_STATUS_SAVE_ERROR: 'We were unable to save your changes. Please try again later',
  DISCOVERY_STATUS_SUCCESS_DISCOVERABLE:
    "Your changes were saved! Your app may take up to 24 hours to appear on Discord's discovery surfaces.",
  DISCOVERY_STATUS_SUCCESS_UNDISCOVERABLE:
    "Your changes were saved! Your app may take up to 24 hours to stop showing up on Discord's discovery surfaces.",

  DISCOVERY_STATUS_HEADING: 'App Discovery Status',
  DISCOVERY_STATUS_SUBHEADING: 'Include or remove your application from discovery surfaces on Discord.',
  DISCOVERY_STATUS_ABOUT:
    "By enabling discovery, you're opting in for your application and its product information to be included in discovery surfaces on Discord **and agree to our [Discovery Policy]({discoveryPolicyLink})**. As a reminder, you and your app are subject to the $[Developer Terms of Service](tosLink) and $[Developer Policy](policyLink). You are also responsible for your app's product information and ensuring that it is accurate and up-to-date. Failure to abide by our terms and policies may result in your app's removal or exclusion from the Discord's discovery surfaces.",

  DISCOVERY_STATUS_TITLE_INELIGIBLE: 'You need to make a few changes',
  DISCOVERY_STATUS_TITLE_UNDISCOVERABLE: "You're ready to go! Click below to become discoverable.",
  DISCOVERY_STATUS_TITLE_DISCOVERABLE: "You're already in! Click below to disable discoverability.",
  DISCOVERY_STATUS_CTA_ENABLE: 'Enable Discovery',
  DISCOVERY_STATUS_CTA_DISABLE: 'Disable Discovery',

  DISCOVERY_STATUS_POLICY_TITLE: 'Verification and Safety',
  DISCOVERY_STATUS_MIGRATION_DESCRIPTION:
    'Your application must use slash commands, or have been approved for the Message Content privileged intent',
  DISCOVERY_STATUS_VERIFICATION_DESCRIPTION: 'Your application must be verified',
  DISCOVERY_STATUS_TWOFA_DESCRIPTION: 'Your Discord account must have Two-Factor authentication enabled',

  DISCOVERY_STATUS_ABOUT_APPLICATION_TITLE: 'Tell Us About Your Application',
  DISCOVERY_STATUS_HAS_SHORT_DESCRIPTION_DESCRIPTION: 'Provide a summary of what your application does',
  DISCOVERY_STATUS_HAS_LONG_DESCRIPTION_DESCRIPTION: 'Provide an expanded description of what your application does',

  DISCOVERY_STATUS_HAS_TAGS_DESCRIPTION: 'Add at least one tag',
  DISCOVERY_STATUS_HAS_SUPPORT_SERVER: 'You must designate a community server as a support server for your application',
  DISCOVERY_STATUS_HAS_SUPPORTED_LOCALES: 'Add at least one locale',

  DISCOVERY_STATUS_LINKS_TITLE: 'Add Application Links',
  DISCOVERY_STATUS_INSTALL_DESCRIPTION: 'Add an Install URL so people can add your application to their server',
  DISCOVERY_STATUS_TOS_DESCRIPTION: 'Provide a link to your Terms of Service',
  DISCOVERY_STATUS_PRIVACY_POLICY_DESCRIPTION: 'Provide a link to your Privacy Policy',

  DISCOVERY_STATUS_LANGUAGE_TITLE: 'Use Appropriate Language',
  DISCOVERY_STATUS_LANGUAGE_NAME_DESCRIPTION: "Your application's name may not contain any harmful or bad language",
  DISCOVERY_STATUS_LANGUAGE_DESCRIPTION_DESCRIPTION:
    'Your application must have a description, and it may not contain any harmful or bad language',
  DISCOVERY_STATUS_LANGUAGE_COMMAND_DESCRIPTION: 'Your commands may not contain any harmful or bad language',
  DISCOVERY_STATUS_LANGUAGE_ROLE_CONNECTIONS_METADATA_DESCRIPTION:
    'Your role connections metadata may not contain any harmful or bad language',

  DISCOVERY_STATUS_APP_BLOCKED_HEADING: 'Your App is Not Eligible for Discovery',
  DISCOVERY_STATUS_APP_BLOCKED_CONTENT: 'Check your email for a message from our Developer Support team',

  DISCOVERY_STATUS_ADMIN_REQUIRED_TO_ENABLE: 'Only Admin team members can enable discovery',

  BOT_HEADING: 'Bot',
  BOT_SUBHEADING: `Bring your app to life on Discord with a Bot user. Be a part of chat in your users' servers and interact with them directly.`,
  BOT_SUBHEADING_LINK: '[Learn more about bot users]({link})',
  BOT_TOKEN_WARNING:
    'For security purposes, tokens can only be viewed once, when created. If you forgot or lost access to your token, please regenerate a new one.',
  BOT_PERMISSIONS_HEADING: 'Bot Permissions',
  BOT_PERMISSIONS_SUBHEADING:
    'Need some help with bit math? Use the tool below to calculate the permissions integer for your bot based on the features it needs.',
  BOT_CREATE_BOT:
    'Bring your app to life by adding a bot user. This action is irreversible (because robots are too cool to destroy).',
  BOT_BUILD: 'Build-A-Bot',
  BOT_ADD_BOT: 'Add Bot',
  BOT_BOT_CREATE_MODAL_LABEL: 'Add a Bot to this App?',
  BOT_BOT_CREATE_MODAL_DESCRIPTION:
    'Adding a bot user gives your app visible life in Discord. However, this action is irrevocable! Choose wisely.',
  BOT_BOT_TOKEN_GENERATE_MODAL_LABEL: `Reset Bot's Token?`,
  BOT_BOT_TOKEN_GENERATE_MODAL_DESCRIPTION: `Your bot will stop working until you update the token in your bot's code.`,
  BOT_BOT_ICON: 'Icon',
  BOT_BOT_DISABLED_ALERT_HEADER: 'Bot Disabled',
  BOT_BOT_DISABLED_ALERT_DESCRIPTION:
    'Your bot has been disabled by Discord. Please [contact us]({url}) for more information.',
  BOT_BOT_QUARANTINED_ALERT_HEADER: 'Bot Quarantined',
  BOT_BOT_QUARANTINED_ALERT_DESCRIPTION:
    'Your bot has been flagged by our anti-spam system for abusive behavior. While your bot is quarantined, it is unable to join any more guilds, or send any direct messages to users it has not messaged before. If you believe this to be in error, [click here]({url}) and select "Appeal an action taken on an app/bot" as the Report Type to submit an appeal.',
  BOT_TOKEN: 'Token',
  BOT_REVEAL_TOKEN: 'Click to Reveal Token',
  BOT_PUBLIC_BOT: 'Public Bot',
  BOT_PUBLIC_BOT_DESCRIPTION:
    'Public bots can be added by anyone. When unchecked, only you can join this bot to servers.',
  BOT_REQUIRE_OAUTH2_CODE_GRANT: 'Requires OAuth2 Code Grant',
  BOT_REQUIRE_OAUTH2_CODE_GRANT_DESCRIPTION: `If your application requires multiple scopes then you may need the full OAuth2 flow to ensure a bot
  doesn't join before your application is granted a token.`,
  BOT_BOT_CREATE_SUCCESS: 'A wild bot has appeared!',
  BOT_BOT_IMG_ALT: 'Cute robot',
  BOT_UPDATE_BOT_SUCCESS: 'Bot successfully updated!',
  BOT_AUTHORIZATION_FLOW: 'Authorization Flow',
  BOT_AUTHORIZATION_FLOW_DESCRIPTION:
    'These settings control how OAuth2 authorizations are restricted for your bot (who can add your bot and how it is added).',
  BOT_UNAPPROVED_INTENTS_WARNING:
    'Your app is temporarily approved for Intents. You may continue to use Privileged Intents until your app joins 100 servers. At that point, you must either apply for full access or turn them off, or your app will not be able to join more servers. You may apply for full access when your app reaches 75 servers.',
  BOT_UNAPPROVED_INTENTS_ERROR:
    'Your app is temporarily approved for Intents and has been limited to joining 100 servers. To enable joining additional servers you must either apply for full access or turn them off, or your app will not be able to join more servers.',
  BOT_GATEWAY_PRIVILEGED_INTENTS: 'Privileged Gateway Intents',
  BOT_GATEWAY_PRIVILEGED_INTENTS_DESCRIPTION: `Some [Gateway Intents]({link}) require approval if your bot is verified. If your bot is not verified, you can toggle those intents below to access them.`,
  BOT_GATEWAY_PRESENCE_LIMITED: 'Presence Intent',
  BOT_GATEWAY_PRESENCE_LIMITED_DESCRIPTION: `Required for your bot to receive [Presence Update]({event}) events.

**NOTE: Once your bot reaches 100 or more servers, this will require verification and approval. [Read more here]({support})**`,
  BOT_GATEWAY_GUILD_MEMBERS_LIMITED: 'Server Members Intent',
  BOT_GATEWAY_GUILD_MEMBERS_LIMITED_DESCRIPTION: `Required for your bot to receive events listed under [GUILD_MEMBERS]({intent}).

**NOTE: Once your bot reaches 100 or more servers, this will require verification and approval. [Read more here]({support})**`,
  BOT_GATEWAY_MESSAGE_CONTENT_LIMITED: 'Message Content Intent',
  BOT_GATEWAY_MESSAGE_CONTENT_LIMITED_DESCRIPTION: `Required for your bot to receive [message content]({faq}) in most messages.

**NOTE: Once your bot reaches 100 or more servers, this will require verification and approval. [Read more here]({support})**`,

  EMOJIS_HEADING: 'Emojis',
  EMOJIS_SUBHEADING: 'Add up to {maxCount, number} custom emoji. These emojis may only be used by the application.',
  EMOJIS_EMPTY_STATE_HEADING: '0 Emojis Uploaded',
  EMOJIS_EMPTY_STATE_SUBHEADING:
    'Get the party started by uploading an emoji. Up to {maxCount, number} custom emojis can be uploaded by an app',
  EMOJIS_REQUIREMENTS_HEADER: 'Upload Requirements',
  EMOJIS_REQUIREMENTS_1: 'File Type: JPEG, PNG, GIF',
  EMOJIS_REQUIREMENTS_2: 'Max file size: 256 KB',
  EMOJIS_REQUIREMENTS_3: 'Recommended dimensions: 128 x 128',
  EMOJIS_REQUIREMENTS_4:
    'Naming: Emoji names must be at least {minLength, number} characters long and can only contain alphanumeric characters and underscores',
  EMOJIS_TABLE_HEADING: 'Emojis - {slots, number} slots available',
  EMOJIS_TABLE_SUBHEADING:
    'Emoji names must be {minLength, number}-{maxLength, number} characters long and can only contain alphanumeric characters and underscores',
  EMOJIS_TABLE_COLUMN_EMOJI: 'Emoji',
  EMOJIS_TABLE_COLUMN_ID: 'Emoji Id',
  EMOJIS_TABLE_COLUMN_UPLOADER: 'Uploaded By',
  EMOJIS_TABLE_NAME_LABEL: 'Emoji Name',
  EMOJIS_UPLOAD_BUTTON: 'Upload Emoji',
  EMOJIS_UPLOAD_ERROR_TOO_LARGE: 'File too large',
  EMOJIS_UPLOAD_ERROR_FILE_INVALID: 'File invalid',
  EMOJIS_ASSETS_IMAGES: 'Images',
  EMOJIS_COPY_MARKDOWN_TOOLTIP: 'Copy Markdown',
  EMOJIS_SEARCH_PLACEHOLDER: 'Search Emojis',

  RICH_PRESENCE_SUBHEADING_LINK: '[Learn more about Rich Presence]({link})',
  RICH_PRESENCE_ASSETS_HEADING: 'Rich Presence Art Assets',
  RICH_PRESENCE_ASSETS_SUBHEADING: `Integrate your game deeply with Discord and let players jump directly into your client and share your game.`,
  RICH_PRESENCE_ASSETS_SUBHEADING_LINK: '[Learn more about Rich Presence Best Practices]({link})',
  RICH_PRESENCE_INVITE_IMAGE_HEADING: 'Rich Presence Invite Image',
  RICH_PRESENCE_INVITE_IMAGE_SUBHEADING: `This is the default image for chat invites, so make sure it's pretty! Put your best face forward :)`,
  RICH_PRESENCE_COVER_IMAGE: 'Cover Image',
  RICH_PRESENCE_IRL_INVITE_IMAGE_EXAMPLE: 'IRL Invite Image Example',
  RICH_PRESENCE_ASSETS_SECTION_HEADING: 'Rich Presence Assets',
  RICH_PRESENCE_ASSETS_SECTION_SUBHEADING:
    'You may add multiple assets that are paired with keys to dynamically update rich presence data for users with images of maps, modes, or whatever works best for your game.',
  RICH_PRESENCE_ASSETS_ADD_IMAGES: 'Add Image(s)',
  RICH_PRESENCE_ASSETS_ACCEPTED_FILE_TYPES:
    '.png, .jpg, or .jpeg — {recommendedSize}x{recommendedSize} recommended, {minSize}x{minSize} minimum',
  RICH_PRESENCE_ASSETS_MANAGER_HEADING: 'Assets ({count, number} of 300)',
  RICH_PRESENCE_ASSET_CACHING_WARNING:
    'Due to caching, asset keys are not editable once they are saved. Delete and re-upload assets if you need to change a key name.',
  RICH_PRESENCE_ASSETS_IMAGES: 'Images',
  RICH_PRESENCE_MINIMUM_ASSET_SIZE: 'Minimum Size: **{size, number}x{size, number}**',
  RICH_PRESENCE_NO_ASSETS_UPLOADED: 'No assets uploaded',
  RICH_PRESENCE_ASSET_NAME_LABEL: 'Asset Name',

  INFORMATION_HEADING: 'General Information',
  INFORMATION_SUBHEADING: `What should we call your creation? What amazing things does it do? What icon should represent it across Discord? Tell us here!`,
  INFORMATION_SUBHEADING_LINK:
    'By clicking Create, you agree to the Discord [Developer Terms of Service]({termsOfServiceLink}) and [Developer Policy]({developerPolicyLink}).',
  INFORMATION_APP_NAME: 'Name',
  INFORMATION_APP_ID: 'Application ID',
  INFORMATION_APP_CLIENT_ID: 'Client ID',
  INFORMATION_APP_CLIENT_SECRET: 'Client Secret',
  INFORMATION_APP_ICON: 'App Icon',
  INFORMATION_APP_ICON_DESCRIPTION: 'Choose a neat icon!',
  INFORMATION_APP_DESCRIPTION: 'Description (maximum {maxLength} characters)',
  INFORMATION_APP_TAGS: 'Tags (maximum {maxLength})',
  INFORMATION_APP_TAGS_DESCRIPTION: `Add up to 5 tags to describe the content and functionality of your application.`,
  INFORMATION_APP_VERIFY_KEY: 'Public Key',
  INFORMATION_APP_INSTALL_COUNT: 'Install Count',
  INFORMATION_APP_INSTALL_COUNT_DESCRIPTION:
    'This is an approximated number of servers and users that have installed your application.',
  INFORMATION_APP_GUILD_INSTALL_COUNT_DESCRIPTION:
    'This is an approximated number of servers that have installed your application.',
  INFORMATION_APP_USER_INSTALL_COUNT_DESCRIPTION:
    'This is an approximated number of users that have installed your application.',
  INFORMATION_APP_INSTALL_COUNT_UPDATE_CADENCE:
    '{count, plural, one {This number is} other {These numbers are}} updated daily.',
  INFORMATION_APP_GUILD_COUNT_VALUE:
    '{guildCount, plural, one {{guildCount, number} Server} other {{guildCount, number} Servers}}',
  INFORMATION_APP_USER_COUNT_VALUE:
    '{userCount, plural, one {{userCount, number} Individual User} other {{userCount, number} Individual Users}}',
  INFORMATION_DELETE_APP: 'Delete App',
  INFORMATION_TRANSFER_APP_OWNERSHIP: 'Transfer App to Team',
  INFORMATION_IRL_EXAMPLE: 'IRL Example',
  INFORMATION_APP_SECRET_REGENERATE_MODAL_LABEL: 'Regenerate Secret Key?',
  INFORMATION_APP_SECRET_REGENERATE_MODAL_DESCRIPTION:
    'Your app will stop working until you update the secret key in your app code.',
  INFORMATION_APP_DELETE_MODAL_LABEL: 'Danger: Deleting Your App!',
  INFORMATION_APP_DELETE_MODAL_DESCRIPTION: `To delete this application, please confirm the name (__!!{name}!!__) below.`,
  INFORMATION_APP_DELETE_MODAL_BOT_WARNING: `Deleting this application will also delete your bot (removing it from every server it is in)!`,
  INFORMATION_APP_DELETE_MODAL_BOT_LEAVE_WARNING: `If your bot is in many servers, you may need to manually leave them before deleting.`,
  INFORMATION_APP_NAME_CONFIRMATION_LABEL: 'App Name',
  INFORMATION_MFA_CODE: '2FA Code',
  INFORMATION_MFA_CODE_PLACEHOLDER: '6-digit authentication code',
  INFORMATION_MFA_BACKUP_PLACEHOLDER: '8-character code',
  INFORMATION_MFA_PASSWORD_PLACEHOLDER: 'Enter your password',
  INFORMATION_SELECT_TEAM_FOR_TRANSFER: 'Select team to transfer to',
  INFORMATION_INSTALL_TYPES: 'Install types',
  INFORMATION_INSTALL_TYPES_DESCRIPTION: 'This is where you define what kinds of installs you allow this app to have',
  INFORMATION_INSTALL_TYPE_GUILD: 'Guild',
  INFORMATION_INSTALL_TYPE_USER: 'User',
  INFORMATION_INTERACTIONS_ENDPOINT_URL: 'Interactions Endpoint URL',
  INFORMATION_INTERACTIONS_ENDPOINT_URL_DESCRIPTION:
    'You can optionally configure an interactions endpoint to receive interactions via HTTP POSTs rather than over Gateway with a bot user.',
  INFORMATION_ROLE_CONNECTIONS_VERIFICATION_URL: 'Linked Roles Verification URL',
  INFORMATION_ROLE_CONNECTIONS_VERIFICATION_URL_DESCRIPTION:
    "You can configure a verification URL to enable your application as a requirement in a server role's Links settings",
  INFORMATION_TOS_URL: 'Terms of Service URL',
  INFORMATION_TOS_URL_DESCRIPTION: `A link to your application's Terms of Service`,
  INFORMATION_PRIVACY_POLICY_URL: 'Privacy Policy URL',
  INFORMATION_PRIVACY_POLICY_URL_DESCRIPTION: `A link to your application's Privacy Policy`,
  INFORMATION_DEEP_LINK_URL: 'Deep Link URL',
  INFORMATION_DEEP_LINK_URL_DESCRIPTION: `The URL which will be opened when a user accepts an activity invitation in the Discord mobile app`,
  INFORMATION_MAXIMUM_PARTICIPANTS: 'Maximum Participants',
  INFORMATION_MAXIMUM_PARTICIPANTS_DESCRIPTION: 'The maximum participants allowed in your activity',
  INFORMATION_APPLICATION_DESCRIPTION_ABOUT_ME_DESCRIPTION: `Your description will appear in the About Me section of your bot's profile.`,
  INFORMATION_UNRELEASED_FIELD: 'Unreleased',

  INSTALLATION_HEADING: 'Installation',
  INSTALLATION_SUBHEADING:
    'Choose how users will install your app. Create an installation link, choose which installation context to support, and define the scopes and permissions you want to request.',
  INSTALLATION_INSTALL_LINK_SECTION_HEADING: 'Install Link',
  INSTALLATION_INSTALL_LINK_SECTION_SUBHEADING: `Use our provided install link or register a custom one. If you choose a custom link, users who add your app will be redirected to your URL instead of the Add App flow in Discord.`,
  INSTALLATION_AUTHORIZATION_METHODS_SECTION_HEADING: 'Installation Contexts',
  INSTALLATION_AUTHORIZATION_METHODS_SECTION_SUBHEADING: `Select the installation contexts your app supports. Apps can be installed to both users and guilds.`,
  INSTALLATION_AUTHORIZATION_METHODS_USER_INSTALL: 'User Install',
  INSTALLATION_AUTHORIZATION_METHODS_USER_INSTALL_DETAILS:
    'Users can add your app to their account and use it everywhere on Discord.',
  INSTALLATION_AUTHORIZATION_METHODS_GUILD_INSTALL: 'Guild Install',
  INSTALLATION_AUTHORIZATION_METHODS_GUILD_INSTALL_DETAILS:
    'Users can add your app to a guild, giving it permissions to take actions in that guild.',
  INSTALLATION_AUTHORIZATION_METHODS_OPTIONS_LABEL: 'Select Methods',
  INSTALLATION_AUTHORIZATION_METHODS_SCOPES_LABEL: 'Scopes',
  INSTALLATION_AUTHORIZATION_METHODS_PERMISSIONS_LABEL: 'Permissions',
  INSTALLATION_APPLICATION_INSTALL_TYPE: 'Authorization Method',
  INSTALLATION_APPLICATION_INSTALL_TYPE_NONE: 'None',
  INSTALLATION_APPLICATION_INSTALL_TYPE_CUSTOM_URL: 'Custom URL',
  INSTALLATION_APPLICATION_INSTALL_TYPE_DISCORD_PROVIDED: 'Discord Provided Link',
  INSTALLATION_APPLICATION_CUSTOM_INSTALL_URL: 'Custom URL',
  INSTALLATION_DEFAULT_SETTINGS_SECTION_HEADING: 'Default Install Settings',
  INSTALLATION_DEFAULT_SETTINGS_SECTION_SUBHEADING:
    'Choose the default set of scopes and permissions your app will request.',

  OAUTH2_HEADING: 'OAuth2',
  OAUTH2_SUBHEADING:
    'Use Discord as an authorization system or use our API on behalf of your users. Add a redirect URI, pick your scopes, roll a D20 for good luck, and go!',
  OAUTH2_SUBHEADING_LINK: '[Learn more about OAuth2]({link})',
  OAUTH2_CLIENT_SECTION_HEADING: 'Client information',
  OAUTH2_APP_CLIENT_ID: 'Client ID',
  OAUTH2_CLIENT_SECRET_HIDDEN: 'Hidden for security',
  OAUTH2_SELECT_REDIRECT_URL: 'Select redirect URL',
  OAUTH2_REDIRECT_URI_LABEL: 'Select redirect URL',
  OAUTH2_SCOPES: 'Scopes',
  OAUTH2_REDIRECT_SECTION_HEADING: 'Redirects',
  OAUTH2_REDIRECT_SECTION_SUBHEADING: `You must specify at least one URI for authentication to work. If you pass a URI in an OAuth request, it must exactly match one of the URIs you enter here.`,
  OAUTH2_BOT_PERMISSIONS: 'Bot Permissions',
  OAUTH2_INVALID_REDIRECT_URI: `You provided an invalid redirect URI.`,
  OAUTH2_INVALID_RPC_ORIGIN: `You provided an invalid RPC origin.`,
  OAUTH2_RPC_ORIGINS: 'RPC Origin(s)',
  OAUTH2_RPC_ORIGIN_URI_LABEL: 'RPC Origin URI',
  OAUTH2_RPC_ORIGINS_DESCRIPTION: `You must specify at least one origin for RPC to work. When establishing a connection to a
                            client RPC, it must exactly match one of the origins you enter here.`,
  OAUTH2_APPLICATION_INSTALL_SECTION_HEADING: 'Default Authorization Link',
  OAUTH2_APPLICATION_INSTALL_SECTION_SUBHEADING: `Pick the scopes and permissions your application needs to function, or add a custom URL. Other Discord users will be able to open your app's profile and directly add it to their server.`,
  OAUTH2_APPLICATION_INSTALL_TYPE: 'Authorization Method',
  OAUTH2_APPLICATION_INSTALL_TYPE_NONE: 'None',
  OAUTH2_APPLICATION_INSTALL_TYPE_CUSTOM_URL: 'Custom URL',
  OAUTH2_APPLICATION_INSTALL_TYPE_OAUTH2_FLOW: 'In-app Authorization',
  OAUTH2_APPLICATION_CUSTOM_INSTALL_URL: 'Custom URL',
  OAUTH2_URL_GENERATOR: 'OAuth2 URL Generator',
  OAUTH2_URL_GENERATOR_DESCRIPTION:
    'Generate an invite link for your application by picking the scopes and permissions it needs to function. Then, share the URL to others!',
  OAUTH2_AUTHORIZATION_URL: 'Generated URL',
  OAUTH2_INTEGRATION_TYPE_SECTION_HEADING: 'Integration Type',
  OAUTH2_PUBLIC_CLIENT: 'Public Client',
  OAUTH2_PUBLIC_CLIENT_DESCRIPTION: `Public clients cannot maintain the confidentiality of their client credentials (i.e. desktop/mobile applications that do not use a server to make requests)`,

  WEBHOOKS_HEADING: 'Webhooks',
  WEBHOOKS_SUBHEADING: 'Configure webhooks for your app to receive via HTTP',
  WEBHOOKS_ENDPOINT_HEADING: 'Endpoint',
  WEBHOOKS_ENDPOINT_SUBHEADING: 'Set a public endpoint URL to receive webhooks. [Learn more]({link})',
  WEBHOOKS_ENDPOINT_URL_FORM_LABEL: 'Endpoint URL',
  WEBHOOKS_ENDPOINT_URL_FORM_PLACEHOLDER: 'Add your endpoint',
  WEBHOOKS_EVENTS_HEADING: 'Events',
  WEBHOOKS_EVENTS_SUBHEADING: 'Send specific events to your application. [Learn more]({link})',

  EVENTS_APPLICATION_AUTHORIZED: 'Application Authorized',
  EVENTS_APPLICATION_COMMAND_PERMISSIONS_UPDATE: 'Application Command Permissions Update',
  EVENTS_AUTO_MODERATION_ACTION_EXECUTION: 'Auto Moderation Action Execution',
  EVENTS_AUTO_MODERATION_RULE_CREATE: 'Auto Moderation Rule Create',
  EVENTS_AUTO_MODERATION_RULE_DELETE: 'Auto Moderation Rule Delete',
  EVENTS_AUTO_MODERATION_RULE_UPDATE: 'Auto Moderation Rule Update',
  EVENTS_CHANNEL_CREATE: 'Channel Create',
  EVENTS_CHANNEL_DELETE: 'Channel Delete',
  EVENTS_CHANNEL_PINS_UPDATE: 'Channel Pins Update',
  EVENTS_CHANNEL_UPDATE: 'Channel Update',
  EVENTS_ENTITLEMENT_CREATE: 'Entitlement Create',
  EVENTS_ENTITLEMENT_DELETE: 'Entitlement Delete',
  EVENTS_ENTITLEMENT_UPDATE: 'Entitlement Update',
  EVENTS_GUILD_AUDIT_LOG_ENTRY_CREATE: 'Guild Audit Log Entry Create',
  EVENTS_GUILD_BAN_ADD: 'Guild Ban Add',
  EVENTS_GUILD_BAN_REMOVE: 'Guild Ban Remove',
  EVENTS_GUILD_DELETE: 'Guild Delete',
  EVENTS_GUILD_EMOJIS_UPDATE: 'Guild Emojis Update',
  EVENTS_GUILD_INTEGRATIONS_UPDATE: 'Guild Integrations Update',
  EVENTS_GUILD_MEMBER_ADD: 'Guild Member Add',
  EVENTS_GUILD_MEMBER_REMOVE: 'Guild Member Remove',
  EVENTS_GUILD_MEMBER_UPDATE: 'Guild Member Update',
  EVENTS_GUILD_ROLE_CREATE: 'Guild Role Create',
  EVENTS_GUILD_ROLE_DELETE: 'Guild Role Delete',
  EVENTS_GUILD_ROLE_UPDATE: 'Guild Role Update',
  EVENTS_GUILD_SCHEDULED_EVENT_CREATE: 'Guild Scheduled Event Create',
  EVENTS_GUILD_SCHEDULED_EVENT_DELETE: 'Guild Scheduled Event Delete',
  EVENTS_GUILD_SCHEDULED_EVENT_UPDATE: 'Guild Scheduled Event Update',
  EVENTS_GUILD_SCHEDULED_EVENT_USER_ADD: 'Guild Scheduled Event User Add',
  EVENTS_GUILD_SCHEDULED_EVENT_USER_REMOVE: 'Guild Scheduled Event User Remove',
  EVENTS_GUILD_STICKERS_UPDATE: 'Guild Stickers Update',
  EVENTS_GUILD_UPDATE: 'Guild Update',
  EVENTS_INTEGRATION_CREATE: 'Integration Create',
  EVENTS_INTEGRATION_DELETE: 'Integration Delete',
  EVENTS_INTEGRATION_UPDATE: 'Integration Update',
  EVENTS_INTERACTION_CREATE: 'Interaction Create',
  EVENTS_INVITE_CREATE: 'Invite Create',
  EVENTS_INVITE_DELETE: 'Invite Delete',
  EVENTS_MESSAGE_CREATE: 'Message Create',
  EVENTS_MESSAGE_DELETE: 'Message Delete',
  EVENTS_MESSAGE_DELETE_BULK: 'Message Delete Bulk',
  EVENTS_MESSAGE_REACTION_ADD: 'Message Reaction Add',
  EVENTS_MESSAGE_REACTION_REMOVE: 'Message Reaction Remove',
  EVENTS_MESSAGE_REACTION_REMOVE_ALL: 'Message Reaction Remove All',
  EVENTS_MESSAGE_REACTION_REMOVE_EMOJI: 'Message Reaction Remove Emoji',
  EVENTS_MESSAGE_POLL_VOTE_ADD: 'Message Poll Vote Add',
  EVENTS_MESSAGE_POLL_VOTE_REMOVE: 'Message Poll Vote Remove',
  EVENTS_MESSAGE_UPDATE: 'Message Update',
  EVENTS_PRIVATE_CHANNEL_INTEGRATION_CREATE: 'Private Channel Integration Create',
  EVENTS_PRIVATE_CHANNEL_INTEGRATION_DELETE: 'Private Channel Integration Delete',
  EVENTS_PRIVATE_CHANNEL_INTEGRATION_UPDATE: 'Private Channel Integration Update',
  EVENTS_QUEST_USER_ENROLLMENT: 'Quest User Enrollment',
  EVENTS_STAGE_INSTANCE_CREATE: 'Stage Instance Create',
  EVENTS_STAGE_INSTANCE_DELETE: 'Stage Instance Delete',
  EVENTS_STAGE_INSTANCE_UPDATE: 'Stage Instance Update',
  EVENTS_THREAD_CREATE: 'Thread Create',
  EVENTS_THREAD_DELETE: 'Thread Delete',
  EVENTS_THREAD_UPDATE: 'Thread Update',
  EVENTS_THREAD_MEMBER_UPDATE: 'Thread Member Update',
  EVENTS_THREAD_MEMBERS_UPDATE: 'Thread Members Update',
  EVENTS_USER_UPDATE: 'User Update',
  EVENTS_VOICE_CHANNEL_STATUS_UPDATE: 'Voice Channel Status Update',
  EVENTS_WEBHOOKS_UPDATE: 'Webhooks Update',

  EVENT_GROUPS_APPLICATIONS: 'Applications',
  EVENT_GROUPS_APPLICATION_COMMANDS: 'Application Commands',
  EVENT_GROUPS_AUTO_MODERATION: 'Auto Moderation',
  EVENT_GROUPS_CHANNELS: 'Channels',
  EVENT_GROUPS_ENTITLEMENTS: 'Entitlements',
  EVENT_GROUPS_GUILDS: 'Guilds',
  EVENT_GROUPS_INTEGRATIONS: 'Integrations',
  EVENT_GROUPS_INVITES: 'Invites',
  EVENT_GROUPS_MESSAGES: 'Messages',
  EVENT_GROUPS_POLLS: 'Polls',
  EVENT_GROUPS_STAGE_INSTANCES: 'Stage Instances',
  EVENT_GROUPS_USERS: 'Users',
  EVENT_GROUPS_VOICE: 'Voice',
  EVENT_GROUPS_WEBHOOKS: 'Webhooks',
  EVENT_GROUPS_QUESTS: 'Quests',

  MY_APPS_APPLICATIONS: 'Applications',
  MY_APPS_PAGE_TITLE: 'My Applications',
  MY_APPS_MY_APPLICATIONS_LABEL: 'My Applications',
  MY_APPS_CREATE_APPLICATION_MODAL_HEADING: 'Create an application',
  MY_APPS_NEW_APPLICATION: 'New Application',
  MY_APPS_INTRO: 'Develop [apps]({link}) to customize and extend Discord for millions of users.',
  MY_APPS_TEAM: 'Team',
  MY_APPS_ERROR_MUST_PROVIDE_NAME: 'A name is required to create your new application.',
  MY_APPS_ERROR_MUST_ACCEPT_TERMS_OF_SERVICE: 'The [Terms of Service]({link}) must be accepted.',
  MY_APPS_PERSONAL: 'Personal',
  MY_APPS_NO_APPS_PRIMARY: `You don't have any applications yet, sad face.`,
  MY_APPS_NO_APPS_SECONDARY: `Click New Application above to get started.`,
  MY_APPS_NO_PERSONAL_APPS_PRIMARY: `You don't have any personal apps.`,
  MY_APPS_NO_PERSONAL_APPS_SECONDARY: `Check out applications for your teams below!`,

  NAVIGATION_SELECTED_APP: 'Selected App',
  NAVIGATION_SETTINGS: 'Settings',
  NAVIGATION_INFORMATION: 'General Information',
  NAVIGATION_BOTS: 'Bot',
  NAVIGATION_APPLICATION_EMOJIS: 'Emojis',
  NAVIGATION_OAUTH2: 'OAuth2',
  NAVIGATION_INSTALLATION: 'Installation',
  NAVIGATION_WEBHOOKS: 'Webhooks',
  NAVIGATION_DISCOVERY: 'Discovery',
  NAVIGATION_DISCOVERY_SETTINGS: 'Discovery Settings',
  NAVIGATION_DISCOVERY_STATUS: 'Discovery Status',
  NAVIGATION_EMBEDDED_APPLICATION: 'Activities',
  NAVIGATION_EMBEDDED_APPLICATION_GETTING_STARTED: 'Getting Started',
  NAVIGATION_EMBEDDED_APPLICATION_SETTINGS: 'Settings',
  NAVIGATION_EMBEDDED_APPLICATION_URL_MAPPINGS: 'URL Mappings',
  NAVIGATION_EMBEDDED_APPLICATION_CUSTOM_LINKS: 'Custom Links',
  NAVIGATION_EMBEDDED_APPLICATION_PUBLISH: 'Publish',
  NAVIGATION_RICH_PRESENCE: 'Rich Presence',
  NAVIGATION_VISUALIZER: 'Visualizer',
  NAVIGATION_ART_ASSETS: 'Art Assets',
  NAVIGATION_WHITELIST: 'App Testers',
  NAVIGATION_VERIFICATION_ONBOARDING: 'App Verification',
  NAVIGATION_SKU_MANAGEMENT: 'Manage SKUs',
  NAVIGATION_STORE_MANAGEMENT: 'Manage Store',
  NAVIGATION_MONETIZATION_ANALYTICS: 'Analytics',
  NAVIGATION_MONETIZATION_GETTING_STARTED: 'Getting Started',
  NAVIGATION_MONETIZATION: 'Monetization',
  NAVIGATION_TEAM: 'Team',
  NAVIGATION_BACK_TO_TEAMS: 'Back to Teams',
  NAVIGATION_SELECTED_TEAM: 'Selected Team',
  NAVIGATION_ANALYTICS: 'Analytics',
  NAVIGATION_ANALYTICS_ACTIVATION: 'Activation',
  NAVIGATION_ANALYTICS_ACQUISITION: 'Acquisition',
  NAVIGATION_ANALYTICS_ENGAGEMENT: 'Engagement',
  NAVIGATION_ANALYTICS_REVENUE: 'Revenue',
  NAVIGATION_PAYOUT_SETTINGS: 'Payout Settings',
  NAVIGATION_PAYOUT_HISTORY: 'Payout History',
  NAVIGATION_RELATED_SKUS: 'Related SKUs',
  NAVIGATION_SERVER_INSIGHTS: 'Server Insights',
  NAVIGATION_GUILD_ANALYTICS_GROWTH_ACTIVATION: 'Growth & Activation',
  NAVIGATION_GUILD_ANALYTICS_ENGAGEMENT: 'Engagement',
  NAVIGATION_GUILD_ANALYTICS_CHANNEL_FOLLOWING: 'Announcement Channels',
  NAVIGATION_GUILD_ANALYTICS_AUDIENCE: 'Audience',
  NAVIGATION_GUILD_ANALYTICS_WELCOME_SCREEN: 'Welcome Screen',
  NAVIGATION_GUILD_ANALYTICS_ROLE_SUBSCRIPTIONS: 'Server Subscriptions',
  NAVIGATION_BACK_TO_APPLICATIONS: 'Back to Applications',
  NAVIGATION_BACK_TO_GUILDS: 'Back to Servers',
  NAVIGATION_ADVANCED_METRICS: 'Advanced Metrics',
  NAVIGATION_AUDIENCE_INSIGHTS: 'Audience Insights',
  NAVIGATION_MESSAGE_REACH: 'Announcement Reach',
  NAVIGATION_SUBSCRIPTIONS: 'Subscriptions',
  NAVIGATION_ITEMS: 'Items',
  NAVIGATION_ON_THIS_PAGE: 'On this page',
  NAVIGATION_DISCORD_SOCIAL_SDK: 'Discord Social SDK',
  NAVIGATION_DISCORD_SOCIAL_SDK_GETTING_STARTED: 'Getting Started',
  NAVIGATION_DISCORD_SOCIAL_SDK_OVERVIEW: 'Overview',
  NAVIGATION_DISCORD_SOCIAL_SDK_EXTERNAL_AUTH_PROVIDERS: 'External Auth',
  NAVIGATION_DISCORD_SOCIAL_SDK_DOWNLOADS: 'Downloads',

  ACTIONS_CANCEL: 'Cancel',
  ACTIONS_SAVE_CHANGES: 'Save Changes',
  ACTIONS_PUBLISH_CHANGES: 'Publish Changes',
  ACTIONS_PUBLISH_SKU: 'Publish SKU',
  ACTIONS_UNPUBLISH_SKU: 'Unpublish SKU',
  ACTIONS_COPY: 'Copy',
  ACTIONS_COPIED: 'Copied',
  ACTIONS_RESET_SECRET: 'Reset Secret',
  ACTIONS_RESET_TOKEN: 'Reset Token',
  ACTIONS_VIEW_TOKEN: 'View Token',
  ACTIONS_LOG_OUT: 'Log Out',
  ACTIONS_RESET: 'Reset',
  ACTIONS_CREATE: 'Create',
  ACTIONS_CONFIRM: 'Confirm',
  ACTIONS_INVITE: 'Invite',
  ACTIONS_REMOVE: 'Remove',
  ACTIONS_TRANSFER: 'Transfer',
  ACTIONS_DELETE: 'Delete',
  ACTIONS_UPLOAD_ASSET: 'Upload Additional Asset',
  ACTIONS_OK: 'Ok',
  ACTIONS_COPY_FAILED: 'Copy Failed',

  ALERTS_SUCCESS_CHANGES_SAVED: 'All your edits have been carefully recorded.',
  ALERTS_ERROR: 'Something went wrong!',
  ALERTS_CANNOT_BE_UNDONE: 'Danger! This cannot be undone.',
  ALERTS_ASSET_UPLOADED: 'Asset successfully uploaded!',

  PRESENCE_VIEWER_USER_ACTIVITY_HEADER_PLAYING: 'Playing a game',
  PRESENCE_VIEWER_USER_ACTIVITY_STATE_SIZE: '({count} of {max})',
  PRESENCE_VIEWER_USER_ACTIVITY_TIMESTAMP_END:
    '{hours, plural, =-1 {} other {{hours}:}}{minutes, plural, =-1 {} other {{minutes}:}}{seconds, plural, =-1 {} other {{seconds}}} left',
  PRESENCE_VIEWER_USER_ACTIVITY_TIMESTAMP_START:
    '{hours, plural, =-1 {} other {{hours}:}}{minutes, plural, =-1 {} other {{minutes}:}}{seconds, plural, =-1 {} other {{seconds}}} elapsed',
  PRESENCE_VIEWER_USER_ACTIVITY_ACTION_ASK_TO_JOIN: 'Ask to Join',
  PRESENCE_VIEWER_SECTION_TITLE: 'Rich Presence Visualizer',
  PRESENCE_VIEWER_SECTION_MORE_INFO: `Rich Presence lets your game surface exciting game data on your players' profiles, and lets them play together with chat invites, and Ask to Join. See exactly how your text and art will look on a user's profile.`,
  PRESENCE_VIEWER_PROFILE: 'Full Profile',
  PRESENCE_VIEWER_USER_POPOUT: 'User Popout',
  PRESENCE_VIEWER_NONE: 'None',
  PRESENCE_VIEWER_SHOW_CODE: 'Show Code',
  PRESENCE_VIEWER_MOBILE_ALERT: 'Rich Presence Visualizer only available on desktop',
  PRESENCE_VIEWER_PARTY_ID_MUST_BE_UNIQUE: `Party ID can't match Join Secrets.`,
  PRESENCE_VIEWER_VISUALIZER_ONLY_NOTICE:
    'This is only a visualizer about how rich presences will look with different assets and settings. Rich presence configuration needs to be programmed in your application. [Learn more about working with Rich Presence]({link})',

  TOOLTIPS_STATE: `[type: char*]\nThe user's current party status`,
  TOOLTIPS_DETAILS: '[type: char*]\nWhat the player is currently doing',
  TOOLTIPS_START_TIMESTAMP: `[type: int64_t]\nEpoch seconds for game start - including will show time as "elapsed"`,
  TOOLTIPS_END_TIMESTAMP: `[type: int64_t]\nEpoch seconds for game end - including will show time as "remaining"	`,
  TOOLTIPS_LARGE_IMAGE_KEY: '[type: char*]\nKey of the uploaded image for the large profile artwork',
  TOOLTIPS_LARGE_IMAGE_TEXT: '[type: char*]\nTooltip for the largeImageKey',
  TOOLTIPS_SMALL_IMAGE_KEY: '[type: char*]\nKey of the uploaded image for the small profile artwork',
  TOOLTIPS_SMALL_IMAGE_TEXT: '[type: char*]\nTooltip for the smallImageKey',
  TOOLTIPS_PARTY_ID: `[type: char*]\nId of the player's party, lobby, or group`,
  TOOLTIPS_PARTY_SIZE: `[type: int]\nCurrent size of the player's party, lobby, or group`,
  TOOLTIPS_PARTY_MAX: `[type: int]\nMaximum size of the player's party, lobby, or group	`,
  TOOLTIPS_JOIN_SECRET: '[type: char*]\nUnique hashed string for chat invitations and Ask to Join',

  USER_PROFILE_USER_INFO: 'User Info',
  USER_PROFILE_MUTUAL_SERVERS: 'Mutual Servers',
  USER_PROFILE_MUTUAL_FRIENDS: 'Mutual Friends',
  USER_PROFILE_NOTE: 'Note',
  USER_PROFILE_ADD_NOTE: 'Click to add note',

  ACTIVE_DEVELOPER_PROGRAM_PAGE_TITLE: 'Active Developer Badge',
  ACTIVE_DEVELOPER_PROGRAM_PAGE_HEADING: 'Active Developer Badge',
  ACTIVE_DEVELOPER_PROGRAM_PAGE_SUBHEADING:
    'Claim your badge by selecting one of your active apps, linking a support server, and following our developer announcements',
  ACTIVE_DEVELOPER_PROGRAM_FORM_HEADING: 'Claim your badge!',
  ACTIVE_DEVELOPER_PROGRAM_FORM_ACTIVE_APPLICATION: 'Select an active application',
  ACTIVE_DEVELOPER_PROGRAM_FORM_SUPPORT_SERVER: 'Set a support server for this application',
  ACTIVE_DEVELOPER_PROGRAM_FORM_ANNOUNCEMENT_CHANNEL: 'Select a channel to subscribe to our announcements',
  ACTIVE_DEVELOPER_PROGRAM_FORM_ACTION: 'Claim',
  ACTIVE_DEVELOPER_PROGRAM_CLAIMED_HEADING: 'You have claimed your Active Developer Badge!',
  ACTIVE_DEVELOPER_PROGRAM_CLAIMED_SUBHEADING: 'Visit your profile to see your new badge!',
  ACTIVE_DEVELOPER_PROGRAM_NOT_ELIGIBLE_HEADING: 'You are not eligible for the Active Developer Badge',
  ACTIVE_DEVELOPER_PROGRAM_NOT_ELIGIBLE_SUBHEADING:
    'For more information on our Developer Badge Requirements [click here]({url})',
  ACTIVE_DEVELOPER_PROGRAM_ERROR: 'Failed to claim',
  ACTIVE_DEVELOPER_PROGRAM_REMOVE_HEADING:
    'No longer want the badge? Click the button below to remove it from your user profile.',
  ACTIVE_DEVELOPER_PROGRAM_REMOVE_CTA: 'Remove Badge',
  ACTIVE_DEVELOPER_PROGRAM_REMOVE_ERROR: 'Sorry, something went wrong. Please try again later.',

  ACTIVE_DEVELOPER_PROGRAM_CTA_HEADING: 'Active Developer Badge',
  ACTIVE_DEVELOPER_PROGRAM_CTA_BODY: 'Come claim your badge by joining our active developer program',
  ACTIVE_DEVELOPER_PROGRAM_CTA_CTA: 'Join',

  LOCALE_DEFAULT_I18N_GROUP_LABEL: 'Default',

  SKU_MANAGEMENT_USER_SUBSCRIPTION_HEADING: 'User Subscription Details',
  SKU_MANAGEMENT_GUILD_SUBSCRIPTION_HEADING: 'Server Subscription Details',
  SKU_MANAGEMENT_OTP_CONSUMABLE_HEADING: 'Consumable Item Details',
  SKU_MANAGEMENT_OTP_DURABLE_HEADING: 'Item Details',
  SKU_MANAGEMENT_PRICE_SUB_PLACEHOLDER: '$ / Month',
  SKU_MANAGEMENT_PRICE_PLACEHOLDER: '$',
  SKU_MANAGEMENT_EDIT_PHOTO: 'Edit Photo',
  SKU_MANAGEMENT_UPDATE_PHOTO: 'Edit Photo',
  SKU_MANAGEMENT_UPLOAD_PHOTO: 'Upload Photo',
  SKU_MANAGEMENT_UPLOAD_PHOTO_DESCRIPTION: 'Upload a PNG, JPG, or GIF under 10MB. Images should be at least 680x240.',
  SKU_MANAGEMENT_UPLOAD_PHOTO_DESCRIPTION_SUB:
    'Upload a PNG, JPG, or GIF under 10MB. Images should be at least 250x250 1:1 ratio.',
  SKU_MANAGEMENT_PAGE_HEADING: 'Manage SKUs',
  SKU_MANAGEMENT_PAGE_SUBHEADING:
    'SKUs are the different items that your players can purchase or get for free. Create them here.',
  SKU_MANAGEMENT_SECTION_HEADING: `{count, plural, one {SKU} other {{count, number} SKUs}}`,
  SKU_MANAGEMENT_NAME: 'Name',
  SKU_MANAGEMENT_NONE: 'None',
  SKU_MANAGEMENT_SKU_TYPE: 'Type',
  SKU_MANAGEMENT_SKU_NAME: 'Name',
  SKU_MANAGEMENT_SKU_DESCRIPTION: 'SKU Description',
  SKU_MANAGEMENT_PRODUCT_DESCRIPTION: 'Item Description',
  SKU_MANAGEMENT_SUBSCRIPTION_NAME: 'Subscription Name',
  SKU_MANAGEMENT_SUBSCRIPTION_DESCRIPTION: 'Subscription Description',
  SKU_MANAGEMENT_PRICE: 'Price',
  SKU_MANAGEMENT_PRICE_TIER: 'Price Tier',
  SKU_MANAGEMENT_STORE_APPLICATION_NAME: 'Store Application Name',
  SKU_MANAGEMENT_LOCALE_DROPDOWN_DESCRIPTION:
    'Use the dropdown below to select the locale you want to change the description for.',
  SKU_MANAGEMENT_ADD_NEW_SKU: 'Create SKU',
  SKU_MANAGEMENT_CREATE_NEW_SKU: 'Create a New SKU',
  SKU_MANAGEMENT_CREATE_NEW_SKU_OF_TYPE: 'Create a new {type} SKU',
  SKU_MANAGEMENT_ADD_SKU_WARNING: 'A SKU cannot be deleted once created.',
  SKU_MANAGEMENT_NO_SKUS_FOUND: 'No SKUs have been created. You should create some!',
  SKU_MANAGEMENT_DUPLICATE_APPLICATION_NAME: 'That name has already been taken.',
  SKU_MANAGEMENT_TOO_MANY_APPLICATION_GAME_SKUS: 'You may not create more than one game SKU per application.',
  SKU_MANAGEMENT_NO_SKUS_TITLE: 'Add your first SKU',
  SKU_MANAGEMENT_NO_SKUS_DESCRIPTION: 'To learn more about setting up your SKUs visit our [help center]({link})',
  SKU_MANAGEMENT_NO_TEAM: 'No team for this App',
  SKU_MANAGEMENT_APPS_MUST_BELONG_TO_TEAM: 'Apps must belong to a Team to start earning.',
  SKU_MANAGEMENT_MANAGE_TEAM: 'Manage Team for this App',
  SKU_MANAGEMENT_SKU_TYPE_SUBSCRIPTION: 'Recurring Subscription',
  SKU_MANAGEMENT_SKU_SUBTEXT_USER_SUBSCRIPTION:
    'An auto-recurring subscription that grants benefits to one user in all servers',
  SKU_MANAGEMENT_SKU_SUBTEXT_GUILD_SUBSCRIPTION:
    'An auto-recurring subscription that grants benefits to all users in one server',
  SKU_MANAGEMENT_OTP_DESC_CONSUMABLE:
    'A one-time purchase that provides a temporary benefit, which is consumed upon use.',
  SKU_MANAGEMENT_OTP_DESC_DURABLE: 'A one-time purchase that grants a permanent addition or enhancement.',
  SKU_MANAGEMENT_LEARN_MORE_ABOUT_SUBSCRIPTIONS_LINK: '[Learn more about user and server subscriptions]({link})',
  SKU_MANAGEMENT_CREATE_SKU_MODAL_HEADER: 'New {type} SKU',
  SKU_MANAGEMENT_CREATE_SKU_MODAL_SUBSCRIPTION_LABEL: 'Subscription Name',
  SKU_MANAGEMENT_CREATE_SKU_MODAL_SKU_LABEL: 'SKU Name',
  SKU_MANAGEMENT_PRICE_LABEL_DAILY: '{price} / {interval, plural, one {Day} other {{interval, number} days}}',
  SKU_MANAGEMENT_PRICE_LABEL_MONTHLY: '{price} / {interval, plural, one {Month} other {{interval, number} months}}',
  SKU_MANAGEMENT_PRICE_LABEL_YEARLY: '{price} / {interval, plural, one {Year} other {{interval, number} years}}',
  SKU_MANAGEMENT_NO_PRICE_SET_LABEL: 'No price set',
  SKU_MANAGEMENT_PRICE_PER_MONTH: 'Price Per Month',
  SKU_MANAGEMENT_MONTHLY_PRICE_DESCRIPTION:
    'Subscription SKUs are automatically charged each month unless cancelled. Changing the price of this SKU will only change it for new subscribers. Existing subscribers will continue to be charged the existing price.',
  SKU_MANAGEMENT_IMAGE: 'Image',
  SKU_MANAGEMENT_BENEFITS: 'Benefits',
  SKU_MANAGEMENT_BENEFITS_DESCRIPTION: 'Explain what your customer will get when purchasing this SKU.',
  SKU_MANAGEMENT_ADD_BENEFIT: 'Add Benefit',
  SKU_MANAGEMENT_SAVE_BENEFIT: 'Save Benefit',
  SKU_MANAGEMENT_EMOJI: 'Emoji',
  SKU_MANAGEMENT_CUSTOM_EMOJI: 'Custom Emoji',
  SKU_MANAGEMENT_DEFAULT_PRICE_IN_USD: 'Price is set in USD and localized automatically at purchase.',

  SKU_MANAGEMENT_PUBLISH_SKU_AVAILABLE_PLUS_STORE: 'Available via Store & API',
  SKU_MANAGEMENT_PUBLISH_SKU_AVAILABLE_PLUS_STORE_DESC: 'Available to be purchased and visible in your app’s store.',
  SKU_MANAGEMENT_PUBLISH_SKU_AVAILABLE: 'Available via API only',
  SKU_MANAGEMENT_PUBLISH_SKU_AVAILABLE_DESC: 'You can only make API calls to grant entitlements for this SKU.',
  SKU_MANAGEMENT_PUBLISH_SKU_DESCRIPTION: 'This SKU will be available for purchase immediately.',
  SKU_MANAGEMENT_UNPUBLISH_SKU_DESCRIPTION: 'Make this SKU unavailable for purchase immediately',
  SKU_MANAGEMENT_UNPUBLISH_SKU_DESCRIPTION_ITEM_1: 'Subscribers will not renew at the end of their billing period',
  SKU_MANAGEMENT_UNPUBLISH_SKU_DESCRIPTION_ITEM_2: 'This SKU can be re-published at any time',
  SKU_MANAGEMENT_UNPUBLISH_AND_DELETE_SKU: 'Unpublish and Delete SKU',
  SKU_MANAGEMENT_DELETE_OTP_ALERT_ITEM_1: 'This will remove this product from being available for purchase.',
  SKU_MANAGEMENT_DELETE_OTP_ALERT_ITEM_2: 'Users who have already purchased this product will still be able to use it',
  SKU_MANAGEMENT_DELETE_SKU_ALERT_ITEM_1: 'This will cancel all active subscriptions to this SKU for all subscribers.',
  SKU_MANAGEMENT_DELETE_SKU_ALERT_ITEM_2: 'They will not renew after their current billing cycle.',
  SKU_MANAGEMENT_DELETE_SKU_WARNING_ITEM_1: 'Your subscribers will receive an email letting them know what happened',
  SKU_MANAGEMENT_DELETE_SKU_WARNING_ITEM_2: 'This SKU will be deleted and unrecoverable',
  SKU_MANAGEMENT_DELETE_SKU_WARNING_ITEM_3: 'This action cannot be undone',
  SKU_MANAGEMENT_DELETE_SKU_CONFIRMATION: 'Please type “Delete” in the field below to delete this SKU',
  SKU_MANAGEMENT_TYPE_DELETE: 'Type “Delete”',
  SKU_MANAGEMENT_REMOVE_BENEFIT: 'Remove Benefit',
  SKU_MANAGEMENT_REMOVE_BENEFIT_DESCRIPTION:
    'Are you sure you want to remove this benefit? This action cannot be undone.',

  SKU_MANAGEMENT_BENEFITS_REORDER: 'Reorder',
  SKU_MANAGEMENT_BENEFITS_SAVE_ORDER: 'Save Order',

  SKU_MANAGEMENT_DONE: 'Done',
  SKU_MANAGEMENT_LEARN_MORE: 'Learn more about SKU types',
  SKU_MANAGEMENT_IN_STOREFRONT: 'Available in your store',

  SKU_MANAGEMENT_MAX_PUBLISHED_SUBSCRIPTIONS_HEADING:
    "You've reached the maximum number of published subscription types",
  SKU_MANAGEMENT_MAX_PUBLISHED_SUBSCRIPTIONS_DESCRIPTION_SERVER:
    'You must first un-publish user subscriptions to publish server subscriptions.',
  SKU_MANAGEMENT_MAX_PUBLISHED_SUBSCRIPTIONS_DESCRIPTION_USER:
    'You must first un-publish server subscriptions to publish user subscriptions.',

  STOREFRONT_ADD_SKU: 'Add SKUs',
  STOREFRONT_ADD_SUBSCRIPTION: 'Add Subscriptions',
  STOREFRONT_SELECT_SKU: 'Select SKU',
  STOREFRONT_SELECT_SKU_DESCRIPTION:
    'Add published SKUs to your storefront. Discord currently supports one published subscription group type at a time.',
  STOREFRONT_ADD_TO_STOREFRONT: 'Add to store',
  STOREFRONT_ALT_SKU_THUMBNAIL: 'SKU labeled {skuName}',
  STOREFRONT_BENEFITS: 'Exclusive to this tier',
  STOREFRONT_EDIT_SKU: 'Edit SKU',
  STOREFRONT_EMPTY_DESCRIPTION:
    'Add a published item or subscription that can be available for purchase in your own storefront.',
  STOREFRONT_EMPTY_DESCRIPTION_OTP: 'Add a product that can be available for purchase in your own store.',
  STOREFRONT_EMPTY_DESCRIPTION_SUBSCRIPTION: 'Add a subscription that can be available for purchase in your own store.',
  STOREFRONT_EMPTY_TITLE: 'Add SKUs to your store',
  STOREFRONT_EMPTY_TITLE_NO_SKUS: 'Publish SKUs to add to store',
  STOREFRONT_EMPTY_TITLE_OTP: 'Add your first product',
  STOREFRONT_EMPTY_TITLE_SUBSCRIPTION: 'Add your first subscription',
  STOREFRONT_LABEL_PRICE_SUBSCRIPTION: '{price} / Mo',
  STOREFRONT_LABEL_PURCHASE: 'Buy for {price}',
  STOREFRONT_LABEL_SUBSCRIBE: 'Subscribe for {price} / Mo',
  STOREFRONT_OTP: 'Item',
  STOREFRONT_PAGE_HEADING: 'Manage Storefront',
  STOREFRONT_ITEMS: 'Items',
  STOREFRONT_PUBLISH: 'Publish',
  STOREFRONT_UNAVAILABLE_FOR_PUBLISHING: 'Unavailable for publishing',
  STOREFRONT_REMOVE_FROM_STOREFRONT: 'Remove from store',
  STOREFRONT_REORDER: 'Reorder',
  STOREFRONT_SAVE: 'Save',
  STOREFRONT_STOREFRONT: 'App Store',
  STOREFRONT_STOREFRONT_TITLE: '{appName} App Store',
  STOREFRONT_SUBSCRIPTION: 'Subscription',
  STOREFRONT_USER_SUBSCRIPTIONS: 'Personal Subscriptions',
  STOREFRONT_SERVER_SUBSCRIPTIONS: 'Server Subscriptions',
  STOREFRONT_SUBSCRIPTIONS: 'Subscriptions',
  STOREFRONT_UNNAMED_ITEM: 'Unnamed item',
  STOREFRONT_UNPUBLISH: 'Unpublish',
  STOREFRONT_NO_SKUS_FOR_STOREFRONT_HEADING: 'You must publish SKUs before adding them to the storefront',
  STOREFRONT_NO_SKUS_FOR_STOREFRONT_DESCRIPTION:
    'Add published SKUs to your storefront. Discord currently supports one published subscription group at a time.',
  ONE_TIME_PURCHASES: 'One Time Purchases',

  EMBEDDED_APPLICATION_SKU_INFORMATION_SUBHEADING: `You probably want to tell people more details about this In-App Purchase SKU. Do that here!`,
  EMBEDDED_APPLICATION_SKU_INFORMATION_PUBLISHED: 'Published',
  EMBEDDED_APPLICATION_SKU_INFORMATION_UNPUBLISHED: 'Unpublished',
  EMBEDDED_APPLICATION_SKU_INFORMATION_PUBLISHED_INFO: 'Controls SKU visibility.',

  EMBEDDED_SKU_TYPES_DURABLE: 'Durable',
  EMBEDDED_SKU_TYPES_SKU_MANAGEMENT_DURABLE: 'Durable',
  EMBEDDED_SKU_TYPES_CONSUMABLE: 'Consumable',
  EMBEDDED_SKU_TYPES_SUBSCRIPTION: 'Subscription',
  EMBEDDED_SKU_TYPES_USER_SUBSCRIPTION: 'User Subscription',
  EMBEDDED_SKU_TYPES_GUILD_SUBSCRIPTION: 'Guild Subscription',
  EMBEDDED_SKU_TYPES_DURABLE_PRIMARY: 'Durable Primary',
  EMBEDDED_SKU_TYPES_SUBSCRIPTION_GROUP: 'Subscription Group',
  EMBEDDED_SKU_TYPES_BUNDLE: 'Bundle',
  EMBEDDED_SKU_TYPES_UNKNOWN: 'Unknown SKU',

  SKU_TYPES_DURABLE_PRIMARY: 'Game',
  SKU_TYPES_DURABLE: 'DLC',
  SKU_TYPES_IAP: 'IAP',
  SKU_TYPES_BUNDLE: 'Bundle',
  SKU_TYPES_SUBSCRIPTION: 'Subscription',
  SKU_TYPES_SUBSCRIPTION_GROUP: 'Subscription Group',

  SKU_ACCESS_TYPES_FULL: 'Full Access',
  SKU_ACCESS_TYPES_EARLY_ACCESS: 'Early Access',
  SKU_ACCESS_TYPES_VIP_ACCESS: 'VIP Access',

  ASSET_LIBRARY_HEADING: 'Asset Library',
  ASSET_LIBRARY_SUBHEADING: 'Upload those assets to showcase your beautiful game.',
  ASSET_LIBRARY_ASSETS_SECTION_HEADING: 'Add Assets',
  ASSET_LIBRARY_ASSETS_SECTION_SUBHEADING: `Add assets that you want to include in your store page. You'll use the assets in the Manage SKUs section when editing your store page.`,
  ASSET_LIBRARY_ASSETS_MANAGER_HEADING: `Assets ({count, number})`,
  ASSET_LIBRARY_ADD_ASSETS: 'Add Assets',
  ASSET_LIBRARY_ASSETS: 'Assets',
  ASSET_LIBRARY_ACCEPTED_FILE_TYPES: '.png, .jpg, .jpeg, .gif, or .mp4',
  ASSET_LIBRARY_SUCCESS: 'Assets successfully added!',

  SKU_PRICE_FREE: 'Free',

  ASSET_MANAGER_ASSET_ERROR: 'There was an error uploading this asset.',

  LOCALES_HEADING: 'Locales',
  LOCALES_SUBHEADING: 'If your game has localized text, cutscenes, or audio, let players know here.',
  LOCALES_AVAILABLE_LOCALES_HEADING: 'Available Locales',

  TEAMS_HEADING: `Teams`,
  TEAMS_INTRO: `Teams let Discord apps and monetization features be managed by a group of people working together. Each team member has admin privileges for anything owned by that team, so only trusted individuals should be added.`,
  TEAMS_PAGE_TITLE: 'My Teams',
  TEAMS_PAGE_SUBHEADING: 'Create a new team to work on cool projects with you, or check out an existing one.',
  TEAMS_PAGE_SUBHEADING_WITH_EXISTING_TEAMS: 'Manage a team and its members by selecting it below.',
  TEAMS_MAX_TEAMS_REACHED: 'Maximum number of teams reached ({maxTeams, number})',
  TEAMS_CREATE_NEW_TEAM: 'Create a team',
  TEAMS_TOO_MANY_TEAMS: 'Maximum number of teams reached. Users may only join or own up to {maxTeams} teams.',
  TEAMS_INFORMATION_PAGE_HEADING: 'Team Information',
  TEAMS_INFORMATION_PAGE_SUBHEADING:
    'Give your team a name and an icon. Add some members, give them roles, and make collaborating easier.',
  TEAMS_INFORMATION_PAGE_REQUIRED_PAYOUT_ALERT: `If you are earning with Server Subscriptions, Activities, or Premium Apps, don't forget to give us your payout information before you start selling.`,
  TEAMS_GO_TO_PAYOUT_SETTINGS: 'Go to Payout Settings',
  TEAMS_TEAM_DETAILS_HEADING: 'Team Details',
  TEAMS_TEAM_NAME_REQUIRED: 'Teams are required to have a name',
  TEAMS_TEAM_SUCCESSFULLY_UPDATED: 'Your team has successfully been updated.',
  TEAMS_TEAM_MEMBERS_HEADING: 'Team Members',
  TEAMS_TEAM_MEMBERS_SUBHEADING: `This is everyone on this team and their role. You can invite new members, change members' roles, or remove someone from the team.`,
  TEAMS_INVITE_TEAM_MEMBERS: 'Invite Team Members',
  TEAMS_TEAM_ROLE: 'Team Role',
  TEAMS_CURRENT_MEMBERS: 'Current Members',
  TEAMS_PENDING: 'Pending',
  TEAMS_TEAM_MEMBER_INVITED: 'New team member successfully invited!',
  TEAMS_REMOVE_TEAM_MEMBER: 'Remove Team Member',
  TEAMS_TEAM_MEMBER_REMOVED: 'Team member successfully removed.',
  TEAMS_INVALID_USERNAME:
    'Invalid username. Please enter a username and discriminator separated by a # to invite a team member.',
  TEAMS_TEAM_MEMBER_ALREADY_EXISTS: 'User is an existing team member, you cannot invite them again.',
  TEAMS_TEAM_MEMBERS_MUST_BE_VERIFIED:
    'Users must add a verified email address to their account before they can be added to a team.',
  TEAMS_TEAM_OWNER_ONLY: 'Only the owner of the team can perform this action.',
  TEAMS_TEAM_MEMBER_REMOVE_WARNING: 'Are you sure you want to remove {memberName} from your team?',
  TEAMS_SELF_REMOVE_WARNING:
    'Are you sure you want to remove yourself from this team? You will not be able to rejoin without a new invitation.',
  TEAMS_TRANSFER_OWNERSHIP: 'Transfer Team Ownership',
  TEAMS_DELETE_TEAM: 'Delete Team',
  TEAMS_SELECT_USER_FOR_TRANSFER: 'Select user to transfer to',
  TEAMS_TEAM_OWNERSHIP_TRANSFERRED: 'Successfully transferred team ownership.',
  TEAMS_TEAM_NOT_LOADED_ERROR: 'Invalid team',
  TEAMS_SUCCESSFULLY_ADDED: 'You have been successfully added to !!{teamName}!!!',
  TEAMS_INVITATION_ALREADY_ACCEPTED: 'You are already a member of this team!',
  TEAMS_UNKNOWN_TEAM_ERROR: 'Team not found.',
  TEAMS_UNKNOWN_TEAM_MEMBER_ERROR: 'Team member or invitation not found.',
  TEAMS_UNKNOWN_USER: 'User does not exist, please make sure username and discriminator are correct.',
  TEAMS_INVALID_INVITE_TOKEN:
    'Your team invitation token is not valid. Please ensure you are logged into the correct account.',
  TEAMS_CANNOT_DELETE_TEAM_WITH_APPLICATIONS: `You can't delete teams with applications. Delete or transfer ownership of this team's applications if you wish to proceed.`,
  TEAMS_CANNOT_DELETE_PREMIUM_MEMBERSHIP_TEAM: `You cannot delete a team with a Server Subscriptions server. To disable Server Subscriptions, please refer to [this guide]({disableServerSubsArticle})`,
  TEAMS_INVALID_ACCOUNT_TYPE: 'Bots and other non-user accounts cannot be added as team members.',
  TEAMS_GENERIC_ACCEPT_INVITATION_ERROR: `There has been an error accepting your team invitation. Please try again, or click [here](https://dis.gd/contact) to contact support.`,
  TEAMS_GENERIC_INVITE_USER_ERROR:
    'There has been an error inviting this team member. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  TEAMS_NEW_TEAM: 'New Team',
  TEAMS_TEAM_NAME: 'Team Name',
  TEAMS_NO_TEAMS_PRIMARY: `You don't have any teams yet, sad face.`,
  TEAMS_NO_TEAMS_SECONDARY: `Click New Team above to get started.`,
  TEAMS_STRIPE_ONBOARDING_FORM_TITLE: `Complete your profile`,

  PAYOUT_SETTINGS_HEADING: 'Payout Settings',
  PAYOUT_SETTINGS_SUBHEADING: `Enter your information so we know where to send your money. **You must use your legal name or business name**, instead of a pseudonym.`,
  PAYOUT_SETTINGS_BODY: `We need to collect information on how to pay you before you can sell on Discord. This is securely collected by a third-party company.`,
  PAYOUT_SETTINGS_ALERT_PENDING: `Your payout information is currently being scrutinized by our financial goblins. We'll notify you when they come to a verdict.`,
  PAYOUT_SETTINGS_ALERT_ACTION_REQUIRED: `After reviewing your payout information, we determined that we need to collect additional information to make a sound decision. Edit by clicking the button below.`,
  PAYOUT_SETTINGS_ALERT_PAYABLE: `Payout info added! Edit at any time by clicking the button below.`,
  PAYOUT_SETTINGS_ALERT_BLOCKED: `You are not eligible to sell on Discord... If you believe there was an error, please [contact our support](https://dis.gd/contact).`,
  PAYOUT_SETTINGS_BUTTON_GET_STARTED: `Get Started`,
  PAYOUT_SETTINGS_BUTTON_EDIT: `Edit Payout Info`,
  PAYOUT_SETTINGS_ALERT_NOT_STRIPE:
    "You're approved for payouts, but not on Stripe. Migrate your account to Stripe or contact [developer support]({developerSupportUrl}).",

  PAYOUT_HISTORY_HEADING: 'Payout History',
  PAYOUT_HISTORY_SUBHEADING: `Every payout transaction will be documented here.`,
  PAYOUT_HISTORY_NO_PAYOUTS_FOUND_PRIMARY: 'No payouts found',
  PAYOUT_HISTORY_NO_PAYOUTS_FOUND_SECONDARY: `There aren't any payouts for this team.`,
  PAYOUT_HISTORY_DATE_RANGE: 'Date range',
  PAYOUT_HISTORY_AMOUNT: 'Amount',
  PAYOUT_HISTORY_STATUS: 'Status',
  PAYOUT_HISTORY_OPEN: 'Open',
  PAYOUT_HISTORY_PAID: 'Paid',
  PAYOUT_HISTORY_PENDING: 'Pending',
  PAYOUT_HISTORY_MANUAL: 'Manual',
  PAYOUT_HISTORY_CANCELED: 'Canceled',
  PAYOUT_HISTORY_CURRENT: 'Current',
  PAYOUT_HISTORY_DOWNLOAD_CSV: 'Download CSV',
  PAYOUT_HISTORY_BY_TRANSACTION: 'By Transaction',
  PAYOUT_HISTORY_BY_SKU: 'By SKU',

  APPLICATION_CHECKLIST_ITEMS_GIVE_GAME_NAME: 'Give your game a name',
  APPLICATION_CHECKLIST_ITEMS_UPLOAD_ICON: 'Give it an icon',
  APPLICATION_CHECKLIST_ITEMS_PROVIDE_DEVELOPER_NAME: 'Tell us who developed it',
  APPLICATION_CHECKLIST_ITEMS_PROVIDE_PUBLISHER_NAME: 'Tell us who published it',
  APPLICATION_CHECKLIST_ITEMS_CREATE_SKU: 'Make your Game SKU',
  APPLICATION_CHECKLIST_ITEMS_WRITE_DEFAULT_DESCRIPTION: 'Write default description',

  RICH_PRESENCE_CHECKLIST_ITEMS_UPLOAD_INVITE_COVER_IMAGE: 'Set a cover image for chat invites',
  RICH_PRESENCE_CHECKLIST_ITEMS_UPLOAD_TWO_ASSETS: 'Upload at least two assets',
  RICH_PRESENCE_CHECKLIST_ITEMS_CONNECT_TO_DISCORD: 'Connect to Discord at least once',

  TEAM_CHECKLIST_ITEMS_TEAM_IS_PAYABLE: 'Submit valid payout information',

  GUILD_CHECKLIST_ITEMS_COMMERCE_GUILD_SELECTED: `Select the server that will be home to your game`,

  ANALYTICS_DATE: 'Date',
  ANALYTICS_INFO_IGNORE_DATE_SELECTOR: `Charts below are independent of the date range or interval you've selected. They are based on **the last 28 days.**`,
  ANALYTICS_NO_DATE_SELECTOR_SUBHEADING: `All data is based on members who visited the server in **the last 28 days.**`,
  ANALYTICS_PREMIUM_GUILD_DATE_LIMIT: `Only data from the last 120 days are available for non-Partner and non-Verified servers.`,
  ANALYTICS_GDPR_DISCREPANCY: `Users who opted-out of analytics tracking will not show up in the data.`,
  ANALYTICS_DATA_UNAVAILABLE_BEFORE_DATE_NOTICE: 'Data is unavailable before {minDate}.',
  ANALYTICS_NO_BOT_ACTIVITY: `Messages from bots are excluded.`,
  ANALYTICS_KEY_METRICS: 'Key Metrics',
  ANALYTICS_KEY_METRICS_LATEST_DATA_TOOLTIP:
    'Key Metrics are always based on the most recent day, week, or month, regardless of the selected date range.',
  ANALYTICS_KEY_METRICS_CHANGE_DAILY: '{pctChange} ({formattedChange}) compared to **yesterday**',
  ANALYTICS_KEY_METRICS_CHANGE_WEEKLY: '{pctChange} ({formattedChange}) compared to **last week**',
  ANALYTICS_KEY_METRICS_CHANGE_MONTHLY: '{pctChange} ({formattedChange}) compared to **last month**',
  ANALYTICS_KEY_METRICS_CHANGE_HOURLY: '{pctChange} ({formattedChange}) compared to **last hour**',
  ANALYTICS_KEY_METRICS_COMPARISON_DATES: 'Comparing {currentDate} to {previousDate}',
  ANALYTICS_GROWTH_ACTIVATION_HEADING: 'Growth & Activation',
  ANALYTICS_ALL_TIME_JOINS: 'All Time Joins',
  ANALYTICS_ALL_TIME_JOINS_TOOLTIP: 'Total number of users who have ever joined this server.',
  ANALYTICS_NEW_COMMUNICATORS: 'New Communicators',
  ANALYTICS_NEW_COMMUNICATORS_TOOLTIP: 'New members who talked (voice or text).',
  ANALYTICS_NEW_MEMBER_RETENTION_TOOLTIP:
    'Percentage of new members that still came back to the server the week after joining.',
  ANALYTICS_MEMBERSHIP_BY_SOURCE_HEADING: 'How many new members are joining?',
  ANALYTICS_MEMBERSHIP_BY_SOURCE_SUBHEADING: 'Also, where are they coming from?',
  ANALYTICS_DISCOVERY_JOINS: 'Server Discovery',
  ANALYTICS_INVITES: 'Invite',
  ANALYTICS_VANITY_JOINS: 'Vanity URL',
  ANALYTICS_HUBS_JOINS: 'Hub',
  ANALYTICS_BOT_JOINS: 'Bot',
  ANALYTICS_INTEGRATION_JOINS: 'Integration',
  ANALYTICS_OTHER_JOINS: 'Others',
  ANALYTICS_TOTAL_MEMBERSHIP_HEADING: 'Total membership over time',
  ANALYTICS_TOTAL_MEMBERS: 'Total members',
  ANALYTICS_SERVER_LEAVES: 'Server leaves over time',
  ANALYTICS_LEAVERS: 'Leavers',
  ANALYTICS_UNKNOWN_CHANNEL: 'Not yet available',
  ANALYTICS_UNKNOWN_CHANNEL_TOOLTIP: 'New Community servers have to wait 24 hours for channel names data',
  ANALYTICS_SERVER_LEAVES_TOOLTIP: 'People who leave on their own. Does not include kicks, prunes, or Discord bans.',
  ANALYTICS_NEW_MEMBER_ACTIVATION_HEADING: 'How many new members successfully activate on their first day?',
  ANALYTICS_NEW_MEMBER_ACTIVATION_SUBHEADING: `A new member is "activated" when they understand what the community is about and why it’s a fit for them. Usually, this is reflected by them at least sending a message or exploring the server beyond the first few channels.`,
  ANALYTICS_NEW_MEMBER_ACTIVATION_SUBHEADING_2: `New members who don't activate tend to remain inactive, so try to improve this. How can you make it easier for new members to onboard into your community?`,
  ANALYTICS_BENCHMARKS_SUBHEADING: `Benchmarks are based on the top active communities on Discord.`,
  ANALYTICS_CHART_LOOKS_CRAZY_NOTICE: `If the chart looks crazy, you may not have enough new members joining daily. Try changing the interval to Weekly or Monthly.`,
  ANALYTICS_NEW_MEMBER_RETENTION_HEADING: 'How many new members retain the next week?',
  ANALYTICS_NEW_MEMBER_RETENTION_SUBHEADING: `Retention measures how many new members stick around in the server beyond their first day. To improve this number, **focus on improving activation (see chart above)** and making your community more active.`,
  ANALYTICS_NEW_MEMBER_RETENTION_SUBHEADING_2: `How to read the numbers: If April 1st has a Week 1 Retention of 20% with 10 new members joining, it means that of the 10 new people who joined, 2 of them came back to the server again the next week (April 8th - April 15th). As such, **the retention line will always be 2 weeks behind the current date**.`,
  ANALYTICS_NEW_MEMBER_RETENTION: 'New Member Retention',
  ANALYTICS_WEEK_ONE_RETENTION: 'Week 1 retention',
  ANALYTICS_RETENTION_BENCHMARK: 'Benchmark: {value} Retained',
  ANALYTICS_NEW_MEMBERS: 'New members',
  ANALYTICS_PCT_TALKED: '% talked (voice or 3+ messages)',
  ANALYTICS_PCT_VISITED_CHANNEL: '% visited more than 3 channels',
  ANALYTICS_PCT_ACTIVATED: '% activated',
  ANALYTICS_ACTIVATION_BENCHMARK: 'Benchmark: {value} Talked',
  ANALYTICS_INVITE_LINK: 'Invite Link',
  ANALYTICS_MOST_POPULAR_INVITES: 'Most popular invites',
  ANALYTICS_REFERRING_DOMAIN: 'Referring Domain',
  ANALYTICS_MOST_POPULAR_REFERRERS: 'Most popular referrers',
  ANALYTICS_REFERRERS_TOOLTIP:
    'Referrer is the website that someone was on before they clicked on your invite link. Not all websites or apps support this.',
  ANALYTICS_VISITORS: 'Visitors',
  ANALYTICS_CHANNEL: 'Channel',
  ANALYTICS_GUILD_NAME: 'Server Name',
  ANALYTICS_GUILD_DESCRIPTION: 'Description',
  ANALYTICS_GUILD_CATEGORY: 'Server Category',
  ANALYTICS_GUILD_MEMBERS: 'Members',
  ANALYTICS_READERS: 'Readers',
  ANALYTICS_MESSAGES: 'Messages',
  ANALYTICS_MESSAGE: 'Message',
  ANALYTICS_DATE: 'Date',
  ANALYTICS_LINK_CLICKS: 'Link Clicks',
  ANALYTICS_COMMUNICATORS_HEADING: 'How many members visited and communicated?',
  ANALYTICS_VISITORS_DESCRIPTION: `A visitor is a member who has clicked into the server and has viewed at least 1 channel.`,
  ANALYTICS_COMMUNICATORS_DESCRIPTION: `A communicator is a visitor who has sent at least 3 messages and/or has spoken in a voice channel.`,
  ANALYTICS_COMMUNICATORS: 'Communicators',
  ANALYTICS_MESSAGE_ACTIVITY_HEADING: 'Message activity',
  ANALYTICS_PCT_COMMUNICATORS: '% communicators',
  ANALYTICS_COMMUNICATORS_BENCHMARK: 'Benchmark: {value} Communicators',
  ANALYTICS_TOTAL_MESSAGES_SENT: 'Total messages sent',
  ANALYTICS_TOTAL_VOICE_MINUTES: 'Total voice minutes',
  ANALYTICS_MESSAGES_SENT: 'Messages sent',
  ANALYTICS_AVERAGE_MESSAGES_PER_COMMUNICATOR: 'Average messages per communicator',
  ANALYTICS_MESSAGES_PER_COMMUNICATOR: 'Messages per communicator',
  ANALYTICS_MESSAGES_BENCHMARK: 'Benchmark: {value} messages per sender',
  ANALYTICS_VOICE_ACTIVITY_HEADING: 'Voice activity',
  ANALYTICS_SPEAKING_MINUTES: 'Speaking minutes',
  ANALYTICS_MUTERS_HEADING: 'How many people muted my server?',
  ANALYTICS_MUTERS_TOOLTIP: `New members are users who have been in your server for less than 1 day.`,
  ANALYTICS_PRUNEABLE_MEMBERS_HEADING: 'How many users can I prune?',
  ANALYTICS_MOST_POPULAR_TEXT_CHANNELS: 'Which text channels do people use the most?',
  ANALYTICS_MOST_POPULAR_VOICE_CHANNELS: 'Which voice channels do people use the most?',
  ANALYTICS_LISTENERS: 'Listeners',
  ANALYTICS_INACTIVE_FOR_NUM_DAYS: 'Inactive for {num} days',
  ANALYTICS_AUDIENCE_HEADING: 'Audience',
  ANALYTICS_AUDIENCE_ANONYMITY_NOTICE: `To protect user privacy, unless a given group has more than 50 members, it will not be shown as a distinct result and may be grouped into “Other.”`,
  ANALYTICS_PARTICIPATORS_BY_REG_COUNTRY_HEADING: 'Which countries are my members from?',
  ANALYTICS_PARTICIPATORS_BY_PLATFORM_HEADING: 'What devices do they use?',
  ANALYTICS_PARTICIPATORS_BY_GUILD_TENURE_HEADING: 'How long have they been a member of the server?',
  ANALYTICS_PARTICIPATORS: 'Participators',
  ANALYTICS_NEW_MEMBERS_BY_DISCORD_TENURE_HEADING: 'Are my new members also new to Discord?',
  ANALYTICS_ACTIVATION_HEADING: 'Activation',
  ANALYTICS_ACTIVATION_SUBHEADING:
    'See if new acquirers are installing and playing your game and if older players are reactivating.',
  ANALYTICS_ACQUISITION_HEADING: 'Acquisition',
  ANALYTICS_ACQUISITION_SUBHEADING:
    'Learn where visitors who acquire your game are coming from. [Learn More]({supportUrl})',
  ANALYTICS_ENGAGEMENT_HEADING: 'Engagement',
  ANALYTICS_ENGAGEMENT_SUBHEADING:
    'Monitor your overall active player base and player retention. [Learn More]({supportUrl})',
  ANALYTICS_ENGAGEMENT_VISITORS_TOOLTIP: 'A member who has clicked into the server and viewed a channel.',
  ANALYTICS_ENGAGEMENT_COMMUNICATORS_TOOLTIP: 'A visitor who sent at least 3 messages and or spoken.',
  ANALYTICS_WELCOME_SCREEN_HEADING: 'Welcome Screen',
  ANALYTICS_WELCOME_SCREEN_VIEWERS: 'People who saw the welcome screen',
  ANALYTICS_WELCOME_SCREEN_FUNNEL_HEADING: 'What are new members clicking and do they activate afterwards?',
  ANALYTICS_WELCOME_SCREEN_FUNNEL_PCT_CLICKED: '% Clicked',
  ANALYTICS_WELCOME_SCREEN_FUNNEL_PCT_SENT_MESSAGE: '% Sent message',
  ANALYTICS_CHANNEL_FOLLOWING_TOTAL_FOLLOWING: 'Total servers following',
  ANALYTICS_CHANNEL_FOLLOWING_NEW_FOLLOWERS_HEADING: 'How many new servers are following me? ',
  ANALYTICS_CHANNEL_FOLLOWING_NEW_FOLLOWERS: 'New followers',
  ANALYTICS_CHANNEL_FOLLOWING_TOTAL_FOLLOWERS_HEADING: 'Total servers following over time',
  ANALYTICS_CHANNEL_FOLLOWING_TOTAL_FOLLOWERS: 'Total followers',
  ANALYTICS_CHANNEL_FOLLOWING_UNFOLLOWERS_HEADING: 'How many servers unfollowed me?',
  ANALYTICS_CHANNEL_FOLLOWING_UNFOLLOWERS: 'Servers unfollowed',
  ANALYTICS_CHANNEL_FOLLOWING_GUILD_SIZE_HEADING: 'What are the sizes of servers following me?',
  ANALYTICS_CHANNEL_FOLLOWING_PUBLISHED_MESSAGES: 'Published messages',
  ANALYTICS_CHANNEL_FOLLOWING_ALL_CHANNELS_OPTION: 'All Channels',
  ANALYTICS_MESSAGE_ID: 'Message ID',
  ANALYTICS_MESSAGE_CONTENTS: 'Message Contents',
  ANALYTICS_SERVERS_REACHED: 'Servers reached',
  ANALYTICS_AVG: 'AVG',
  ANALYTICS_WEEK: 'Week',
  ANALYTICS_EIGHT_WEEK_PERIOD: '8 WEEK PERIOD',
  ANALYTICS_REVENUE_HEADING: 'Revenue',
  ANALYTICS_REVENUE_SUBHEADING:
    'See all transactions and activity related to your game revenue. Acquisition of free content will not show here. [Learn More]({supportUrl})',
  ANALYTICS_HOURLY: 'Hourly',
  ANALYTICS_DAILY: 'Daily',
  ANALYTICS_WEEKLY: 'Weekly',
  ANALYTICS_MONTHLY: 'Monthly',
  ANALYTICS_AGGREGATION_INTERVAL: 'Interval',
  ANALYTICS_DATE_RANGE: 'Date Range',
  ANALYTICS_PREVIOUS: 'Previous',
  ANALYTICS_NEXT: 'Next',
  ANALYTICS_PAGE_VIEWS: 'Page Views',
  ANALYTICS_CVR: '% CVR',
  ANALYTICS_PERCENT_CTR: '% CTR',
  ANALYTICS_CTR: 'CTR',
  ANALYTICS_ACQUISITIONS: 'Acquisitions',
  ANALYTICS_EXTERNAL_CONVERSIONS: 'Acquisitions from External Referrals',
  ANALYTICS_UTM_CONVERSIONS: 'Acquisitions from Tracked UTM Links',
  ANALYTICS_UTM_SOURCE: 'Source',
  ANALYTICS_UTM_MEDIUM: 'Medium',
  ANALYTICS_UTM_CAMPAIGN: 'Campaign',
  ANALYTICS_UTM_TERM: 'Term',
  ANALYTICS_UTM_CONTENT: 'Content',
  ANALYTICS_IMPRESSION_TYPE: 'Impression Type',
  ANALYTICS_IMPRESSIONS: 'Impressions',
  ANALYTICS_REACTIONS: 'Reactions',
  ANALYTICS_PERCENT_ALL_IMPRESSIONS: '% All Impressions',
  ANALYTICS_NO_DATA_FOR_PERIOD: 'No data for selected period.',
  ANALYTICS_IN_APP_IMPRESSIONS: 'Acquisitions from Impressions',
  ANALYTICS_NET_REVENUE_CHART: 'Net Revenue by SKU by Day',
  ANALYTICS_NET_REVENUE: 'Net Revenue',
  ANALYTICS_NET_REVENUE_BY_COUNTRY: 'Net Revenue by Country',
  ANALYTICS_NET_UNITS_CHART: 'Net Units Sold by SKU by Day',
  ANALYTICS_NET_UNITS: 'Net Units Sold',
  ANALYTICS_NET_UNITS_BY_COUNTRY: 'Net Units Sold by Country',
  ANALYTICS_SKU_PERFORMANCE_TABLE: 'SKU Performance',
  ANALYTICS_SKU_NAME: 'SKU Name',
  ANALYTICS_GROSS_UNITS_SOLD: 'Gross Units Sold',
  ANALYTICS_REFUNDED_UNITS: 'Refunded Units',
  ANALYTICS_NET_UNITS_SOLD: 'Net Units Sold',
  ANALYTICS_SHARE_OF_UNITS: '% Total Units',
  ANALYTICS_GROSS_REVENUE: 'Gross Revenue',
  ANALYTICS_TAXES: 'Taxes',
  ANALYTICS_FEES: 'Fees',
  ANALYTICS_REFUND_AMOUNT: 'Refunds, Chargebacks, Fraud (RCF)',
  ANALYTICS_SHARE_OF_REVENUE: '% Total Revenue',
  ANALYTICS_ACQUISITIONS_BY_COUNTRY: 'Acquisitions by Country',
  ANALYTICS_STORE_LISTING_PAGE_VIEWS: 'Store Listing Page Views by Source',
  ANALYTICS_OTHER: 'Other',
  ANALYTICS_EXPORT_CSV: 'Export CSV',
  ANALYTICS_LEARN_MORE: 'Learn More',
  ANALYTICS_ACTIVE_PLAYERS_CHART: 'Active Players By Country',
  ANALYTICS_PLAYER_RETENTION_CHART: 'Player Cohort Retention',
  ANALYTICS_PLAYERS: 'Players',
  ANALYTICS_RETENTION: '% Retention',
  ANALYTICS_PERCENT_WEEK_ONE: '% Week 1',
  ANALYTICS_PERCENT_WEEK_TWO: '% Week 2',
  ANALYTICS_PERCENT_WEEK_FOUR: '% Week 4',
  ANALYTICS_PERCENT_WEEK_EIGHT: '% Week 8',
  ANALYTICS_INSTALLATIONS: 'Installations',
  ANALYTICS_ACQUIRE_TO_PLAY_FUNNEL: 'Acquire to Play Funnel',
  ANALYTICS_NEW_PLAYERS: 'New Players',
  ANALYTICS_NEW_PLAYERS_WITH_EXPLANATION: 'New Players (1st Time Played)',
  ANALYTICS_REACTIVATED_PLAYERS: 'Reactivated Players',
  ANALYTICS_REACTIVATED_PLAYERS_WITH_EXPLANATION: 'Reactivated Players (1st Time Played in 30 Days)',
  ANALYTICS_TOTAL: 'Total',
  ANALYTICS_UNIQUE: 'Unique',
  ANALYTICS_UTM_TABLE_EMPTY:
    'You can track conversions of traffic to your Discord store page. [Click here]({supportUrl}) to learn more.',
  ANALYTICS_DATA_CURRENT_THROUGH: 'Data current through',
  ANALYTICS_DATA_CURRENT_THROUGH_VALUE: 'Last updated {date} (UTC)',
  ANALYTICS_DATA_AS_OF_DATE_WARNING: 'Data is currently only available through {date} (UTC).',
  ANALYTICS_JOINS: 'Joins',
  ANALYTICS_VIEWERS: 'Viewers',
  ANALYTICS_JOINS_BY_SOURCE: 'Where are new server members coming from?',
  ANALYTICS_MESSAGE_CONTENT: 'Message Content',
  ANALYTICS_SERVERS_FOLLOWING: 'Servers Following',
  ANALYTICS_USERS: 'Users',
  ANALYTICS_GUILD_ANALYTICS_CHANNEL_FOLLOWING_HEADING: 'Announcement Channels',
  ANALYTICS_MEMBERS: 'Members',
  ANALYTICS_LURKERS: 'Lurkers',
  ANALYTICS_CHATTERS: 'Chatters',
  ANALYTICS_CHANNEL_NAME: 'Channel Name',
  ANALYTICS_GUILD_SIZE_REQUIRED: 'Your server must have more than 500 members to view these stats.',
  ANALYTICS_CHART_DATA_ACCURACY_ISSUE_WARNING:
    'We are aware of issues with the data accuracy within these charts. The team is on and will fix it ASAP.',
  ANALYTICS_SKU_ID: 'SKU ID',

  // Role Subscriptions
  ANALYTICS_ROLE_SUBSCRIPTIONS_HEADING: 'Server Subscriptions',
  ANALYTICS_ROLE_SUBSCRIPTIONS_MONTHLY_REVENUE: 'Estimated Monthly Revenue',
  ANALYTICS_ROLE_SUBSCRIPTIONS_MONTHLY_REVENUE_TOOLTIP:
    'Estimate based on {subscribers} paying subscribers (excluding those that have cancelled). Actual revenue may vary.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_ACTIVE_MEMBERS: 'Paying Members',
  ANALYTICS_ROLE_SUBSCRIPTIONS_ACTIVE_MEMBERS_TOOLTIP:
    'Members with active paid subscriptions. Does not include free trials.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_MONTHLY_REVENUE_DISCLAIMER:
    'Some subscriber payments may not be included in the current month, but the following one. Please refer to [this article]({articleUrl}) for more information.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_REVENUE_HEADING: 'What is my revenue per tier?',
  ANALYTICS_ROLE_SUBSCRIPTIONS_REVENUE_SUBTITLE: 'Revenue includes fees and deductions.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_REVENUE_BY_PLATFORM_HEADING: 'What is my revenue per platform?',
  ANALYTICS_ROLE_SUBSCRIPTIONS_REVENUE_BY_PLATFORM_SUBTITLE: 'Revenue includes fees and deductions.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_ACTIVE_MEMBERS_HEADING: 'How many active members do I have in each tier?',
  ANALYTICS_ROLE_SUBSCRIPTIONS_MEMBER_SIGNUPS_HEADING: 'How many new members are subscribing?',
  ANALYTICS_ROLE_SUBSCRIPTIONS_CANCELLATION_HEADING: 'Member Cancellations',
  ANALYTICS_ROLE_SUBSCRIPTIONS_CANCELLATION_SUBTITLE:
    'A cancellation occurs when a Premium member chooses to end their subscription.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_MEMBER_CHURN_HEADING: 'Member Churn',
  ANALYTICS_ROLE_SUBSCRIPTIONS_MEMBER_CHURN_SUBTITLE:
    'Churn occurs at the end of a canceled subscription’s billing period.',
  ANALYTICS_ROLE_SUBSCRIPTIONS_TRIALS_STARTED_HEADING: 'Trials Started',
  ANALYTICS_ROLE_SUBSCRIPTIONS_ACTIVE_TRIALS_HEADING: 'Active Trials',
  ANALYTICS_ROLE_SUBSCRIPTIONS_TRIALS_CONVERSION_HEADING: 'How many trials converted to paid memberships?',

  // Server insights upsell
  ANALYTICS_ADD_ONBOARDING: 'Add onboarding to improve retention',
  ANALYTICS_ADD_ONBOARDING_SUBTITLE:
    ' Make joining less overwhelming for new members. Let users easily choose roles without bots.',
  ANALYTICS_ADD_ONBOARDING_CTA: "Let's Go!",
  ANALYTICS_TESTIMONIAL_TEXT:
    'This feature has allowed us to remove command verification, increasing our overall member retention by a good 10-20% LOVE this feature :)',
  ANALYTICS_TESTIMONIAL_USER: 'Keiran, Teamagers admin',

  // Project Tetris
  ANALYTICS_PROJECT_TETRIS_AUDIENCE_HEADING: 'Advanced Audience Insights',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH_HEADING: 'Advanced Message Reach',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH: 'Message Reach',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH_SELECT_REACH_TYPE_OPTION_DIRECT: 'View reach within my server',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH_SELECT_REACH_TYPE_OPTION_CROSSPOSTED: 'View reach from following servers',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH_SELECT_REACH_TYPE_OPTION_TOTAL: 'View total reach',
  ANALYTICS_PROJECT_TETRIS_ACTIVITY_BY_DAY_OF_WEEK_HEADING: 'Activity by Day of the Week',
  ANALYTICS_PROJECT_TETRIS_ACTIVITY_BY_TIME_OF_DAY_HEADING: 'Activity by Time of the Day',
  ANALYTICS_PROJECT_TETRIS_ACTIVITY_BY_TIME_OF_DAY_TOOLTIP:
    'Displayed in your local time ({abbreviatedTimezoneString})',
  ANALYTICS_PROJECT_TETRIS_INFERRED_AGE_DISTRIBUTION: 'Inferred Age Distribution',
  ANALYTICS_PROJECT_TETRIS_INFERRED_GENDER_DISTRIBUTION: 'Inferred Gender Distribution',
  ANALYTICS_PROJECT_TETRIS_LANGUAGE_DISTRIBUTION: 'Language Distribution',
  ANALYTICS_PROJECT_TETRIS_OTHER_GUILD_MEMBERSHP: 'My Members Also Belong To...',
  ANALYTICS_PROJECT_TETRIS_OTHER_GUILD_INTERESTS: 'My Members Are Interested In...',
  ANALYTICS_PROJECT_TETRIS_ANNOUNCEMENT_MESSAGE_IMPRESSIONS: 'Announcement Reach',
  ANALYTICS_PROJECT_TETRIS_GUILD_LEAVE_REASON: 'Why Members Are Leaving?',
  ANALYTICS_PROJECT_TETRIS_CHANNEL: 'Channel',
  ANALYTICS_PROJECT_TETRIS_NUM_PARTICIPANTS: '# Users',
  ANALYTICS_PROJECT_TETRIS_GUILDS_FOLLOWING: 'Discoverable Servers Following My Channels',
  ANALYTICS_PROJECT_TETRIS_GUILDS_FOLLOWING_TABLE_SIZE: 'Size',
  ANALYTICS_PROJECT_TETRIS_GUILDS_FOLLOWING_TABLE_CATEGORY: 'Category',
  ANALYTICS_PROJECT_TETRIS_GUILDS_FOLLOWING_NO_DATA_MESSAGE: 'Ahhh, feel the breeze',
  ANALYTICS_PROJECT_TETRIS_GUILDS_FOLLOWING_NO_RESULTS_FOR_FILTERS: 'No results for the selected filters.',
  ANALYTICS_PROJECT_TETRIS_GUILDS_FOLLOWING_NO_FOLLOWERS: 'Uh oh, looks like no one is following you yet.',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH_MESSAGE_FAILED_TO_LOAD: 'Failed to load message.',
  ANALYTICS_PROJECT_TETRIS_MESSAGE_REACH_REACTION_OVERFLOW_COUNT: '+{numReactions, number} more',
  ANALYTICS_PROJECT_TETRIS_AGGREGATE_TOPIC: 'Topic',
  ANALYTICS_PROJECT_TETRIS_NUM_CONVERSATIONS: '# Conversations',
  ANALYTICS_PROJECT_TETRIS_NUM_MESSAGES: '# Messages',
  ANALYTICS_PROJECT_TETRIS_NUM_USERS: '# Users',
  ANALYTICS_PROJECT_TETRIS_LAST_UPDATE_UTC: `Last updated {date} (UTC)`,
  ANALYTICS_NONE: 'None',

  METADATA_HEADING: 'Game Metadata',
  METADATA_SUBHEADING: `Update your game's metadata here!`,
  METADATA_PUBLISHERS: 'Publishers',
  METADATA_DEVELOPERS: 'Developers',
  METADATA_MAX_COMPANIES_REACHED: `You've created the maximum number of companies ({maxCompanies, number}). For help deleting companies, please [contact our support team](https://dis.gd/contact).`,

  MULTITEXT_INPUT_ADD_ONE: 'Add {name}',
  MULTITEXT_INPUT_ADD_ANOTHER: 'Add Another',

  ADDRESS_COUNTRY: 'Country',

  ERRORS_ERROR_LOADING_ASSETS: 'Error loading store assets',
  ERRORS_ERROR_LOADING_GUILDS: 'Error loading servers',
  ERRORS_ERROR_LOADING_APPLICATIONS:
    'Error fetching applications. Please reload page, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_TRANSFERRING:
    'Error completing transfer. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_SUBMITTING_FORM:
    'Error submitting form. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_CREATING_TEAM:
    'Error creating Team. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_FETCHING_TEAMS:
    'Error fetching teams. Please reload page, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_DELETING_TEAM_MEMBER:
    'Error deleting team member. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_DELETING_TEAM:
    'Error deleting team. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_ACTIVATING_LICENSE:
    'Error activating license. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_LOADING_ANALYTICS_DATA:
    'Error loading analytics data. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_LOADING_APPLICATION_EMOJIS:
    'Error loading application emojis. Please try again, or click [here](https://dis.gd/contact) to contact support.',
  ERRORS_VALIDATION_ERRORS: 'Validation errors:',
  ERRORS_VERIFIED_EMAIL_REQUIRED: 'You must add a verified email address to access this feature.',
  ERRORS_ERROR_LOADING_PROXY_CONFIG: 'Error fetching application proxy config',
  ERRORS_ERROR_LOADING_EMBEDDED_ACTIVITY_CONFIG: 'Error fetching activity config',
  ERRORS_ERROR_LOADING_APPLICATION_COMMANDS: 'Error fetching application commands',
  ERRORS_ERROR_NO_PRIMARY_ENTRY_POINT_APPLICATION_COMMANDS: `Your activity may not be launchable because it's missing an Entry Point command. Read more about [Entry Points in our documentation]({url}).`,
  ERRORS_ERROR_SAVING_SKU_BENEFITS: 'Error saving benefits',
  ERRORS_ERROR_TOO_MANY_LISTINGS:
    'Too many listings attached to this SKU. Click [here](https://dis.gd/contact) to contact support.',
  ERRORS_ERROR_LOCALHOST_INVALID_TARGET: 'Error: "localhost" is an invalid url target.',
  ERRORS_ERROR_SAVING_STORE: 'Error saving store',
  ERRORS_ERROR_SAVING_EXTERNAL_AUTH_PROVIDER: 'Error saving external auth provider.',
  ERRORS_ERROR_REMOVING_EXTERNAL_AUTH_PROVIDER: 'Error removing external auth provider.',
  ERRORS_ERROR_ENABLING_SOCIAL_SDK: 'Error enabling social SDK.',

  SOCIAL_MEDIA_TWITTER_HANDLE: '@Discord',

  GUILDS_HEADING: 'Server Insights',
  GUILDS_INTRO: `Here are the servers you have permission to view Server Insights for. Click on any of them to view insightful analytics about your communities, like how engaged your members are and how fast you're growing.`,
  GUILDS_NO_GUILDS_PRIMARY: `You don't have any servers in here yet :(`,
  GUILDS_NO_GUILDS_SECONDARY: `Servers in which you have the "View Server Insights" permission will show up.`,
  GUILDS_SERVER_IS_NOT_READY_YET: `Your server isn't quite ready yet`,
  GUILDS_MY_SERVERS: 'My Servers',

  REQUEST_ADDITIONAL_INTENTS_ALERT_APPROVED_APP_REQUEST_INTENTS_HEADING: 'Request approval for Privileged Intents',
  REQUEST_ADDITIONAL_INTENTS_ALERT_APPROVED_APP_REQUEST_INTENTS_CTA_TEXT:
    'Verified apps cannot use [Privileged Intents]({link}) without being approved. Apply for approval if you require Privileged Intents for new functionality.',
  REQUEST_ADDITIONAL_INTENTS_ALERT_LIMITED_INTENTS_WARNING_HEADING: 'Your growth is being capped',
  REQUEST_ADDITIONAL_INTENTS_ALERT_LIMITED_INTENTS_WARNING:
    'Your app has been verified, but you have Limited [Privileged Intents]({link}) enabled on your app. You will not be able to grow past 100 servers unless these are disabled or you apply for [Privileged Intents]({link}) and are approved',
  REQUEST_ADDITIONAL_INTENTS_ALERT_LIMITED_INTENTS_DANGER_HEADING: 'Your app cannot be added to more guilds',
  REQUEST_ADDITIONAL_INTENTS_ALERT_LIMITED_INTENTS_DANGER:
    'Your app has been verified, but you have Limited [Privileged Intents]({link}) enabled on your app. Your app is blocked from being added to more servers until these are disabled or you apply for [Privileged Intents]({link}) and are approved',
  REQUEST_ADDITIONAL_INTENTS_ALERT_SUBMISSION_NOT_AVAILABLE:
    'This application is not currently in the minimum number of servers required to apply intent verification.',
  REQUEST_ADDITIONAL_INTENTS_ALERT_REQUEST_INTENTS_CTA_BUTTON: 'Apply',
  REQUEST_ADDITIONAL_INTENTS_CHECKLIST_TITLE: 'Intent Verification Qualifications',
  REQUEST_ADDITIONAL_INTENTS_CHECKLIST_SUBTITLE_INCOMPLETE:
    "Your app's intents are missing {numberTodo} {numberTodo, plural, one {criterion} other {criteria}} and cannot be submitted for approval",
  REQUEST_ADDITIONAL_INTENTS_CHECKLIST_SUBTITLE_COMPLETE: 'Intent Verification qualification complete',
  REQUEST_ADDITIONAL_INTENTS_APPLICATION_DESCRIPTION_HEADING: 'Application Details',
  REQUEST_ADDITIONAL_INTENTS_APPLICATION_DESCRIPTION_SUBHEADING:
    'What does your application do? Please be as detailed as possible, and feel free to include links to image or video examples.',
  REQUEST_ADDITIONAL_INTENTS_HEADING: 'Request Intents',
  REQUEST_ADDITIONAL_INTENTS_CURRENT_LIMITED_INTENTS:
    'You have the following limited intents and may apply for their full intents: {list}.',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_MEMBERS_REASON_LABEL: 'Why do you need the Guild Members intent?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_MEMBERS_STORED_LABEL:
    'Are you storing any potentially sensitive user information off-platform (outside of Discord)?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_MEMBERS_AUTODELETE_LABEL:
    'Are you storing potentially sensitive user information, including usernames, nicknames, and avatars, for 30 days or less?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_PRESENCES_REASON_LABEL:
    'Why do you need the Guild Presences intent?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_PRESENCES_CAN_OPT_OUT_LABEL:
    'Can users opt-out of having their Presence data tracked?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_PRESENCES_STORED_LABEL:
    'Are you storing user activity data off-platform (outside of Discord)?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_GUILD_PRESENCES_AUTODELETE_LABEL:
    'Are you storing user activity data for 30 days or less?',
  REQUEST_ADDITIONAL_INTENTS_MESSAGE_CONTENT_AI_TRAINING_PT_1:
    'Will the message content data be used to train machine learning or AI Models?',
  REQUEST_ADDITIONAL_INTENTS_MESSAGE_CONTENT_AI_TRAINING_PT_2:
    'If yes, please explain how in the text box below, including how such models would be used.',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_MESSAGE_CONTENT_REASON_LABEL:
    'Why do you need the Message Content intent?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_MESSAGE_CONTENT_CAN_OPT_OUT_LABEL:
    'Can users opt-out of having their message content data tracked?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_MESSAGE_CONTENT_STORED_LABEL:
    'Are you storing message content data off-platform (outside of Discord)?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_MESSAGE_CONTENT_AUTODELETE_LABEL:
    'Are you storing user message content data for 30 days or less?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_USE_CASE_LABEL: `Please describe the feature you're building using this intent with as much detail as possible.`,
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_DEMONSTRATION_LABEL:
    'Please provide links to screenshots and/or videos that demonstrate your use case',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_DEMONSTRATION_PLACEHOLDER:
    'For each selected intent, we require you to provide a link to screenshots or video that demonstrates your desired use case working within a Discord server.',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_DELETION_LABEL:
    'How do users contact you to request deletion of their activity data?',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_DELETION_PLACEHOLDER:
    'Provide a bot command, server link, email address, or other contact information here.',
  REQUEST_ADDITIONAL_INTENTS_DATA_COLLECTION_ENCRYPTION_LABEL:
    'Are you encrypting your stored potentially sensitive user information data at rest, as is required by our Developer Policy?',
  REQUEST_ADDITIONAL_INTENTS_PRIVACY_POLICY_PUBLIC_LABEL:
    'Do you have a public Privacy Policy telling your users about their data usage?',
  REQUEST_ADDITIONAL_INTENTS_PRIVACY_POLICY_LOCATION_LABEL: 'Where is your Privacy Policy available?',
  REQUEST_ADDITIONAL_INTENTS_PRIVACY_POLICY_LOCATION_PLACEHOLDER:
    'Some examples include a link within your bot bio, a help command, a rules channel, a DM sent to users upon guild join, or any other form of notification.',
  REQUEST_ADDITIONAL_INTENTS_PRIVACY_POLICY_EXAMPLE_LABEL: 'Please share your Privacy Policy',
  REQUEST_ADDITIONAL_INTENTS_PRIVACY_POLICY_EXAMPLE_PLACEHOLDER:
    'Provide a link or screenshots of your Privacy Policy.',
  REQUEST_ADDITIONAL_INTENTS_SUBMISSION_RECEIVED: 'Your submission was received.',

  VERIFICATION_ALERT_REQUIRED_HEADING: 'Verification Required',
  VERIFICATION_ALERT_REQUIRED_BODY:
    'You must verify your identity and submit your application for approval before growing past 100 guilds. [Learn more]({url}).',
  VERIFICATION_ALERT_REQUIRED_CTA: 'Get Started',
  VERIFICATION_ALERT_SUBMITTED_HEADING: 'Verification Request Processing',
  VERIFICATION_ALERT_SUBMITTED_BODY: `We've received your request. We are reviewing your verification form and will reach out to you via email
  with more information.`,
  VERIFICATION_IMMUTABLE_FIELDS_NOTICE: `Once this form is submitted, you will no longer be able to change the bot's name or ownership (this includes transferring to and from developer teams). Please make any necessary changes before submitting this application.`,
  VERIFICATION_HEADING: 'Verification',
  VERIFICATION_SUBHEADING:
    'In order to scale your application past 100 servers, we require you to complete identity and application verification. [Learn more]({url}).',
  VERIFICATION_IDENTITY_HEADING: 'Identity Verification',
  VERIFICATION_IDENTITY_SUBHEADING: `We've partnered with Stripe to power our identity verification. Clicking the button below will open a popup to begin the process. You'll be asked to take a photo or upload a scanned copy of your identity document(s) like a driver's license, ID card, or passport.`,
  VERIFICATION_IDENTITY_VERIFY: 'Verify Me',
  VERIFICATION_IDENTITY_VERIFY_OWNER_ONLY_TOOLTIP: 'You must be the team owner',
  VERIFICATION_IDENTITY_VERIFIED_HEADING: 'Identity Verification Completed',
  VERIFICATION_IDENTITY_VERIFIED: 'Verified',
  VERIFICATION_IDENTITY_PROCESSING_HEADING: 'Processing Identity Verification',
  VERIFICATION_IDENTITY_PROCESSING: `Hang tight, we're still processing your submission.. This can take a few minutes.`,
  VERIFICATION_IDENTITY_REQUIRES_ACTION_HEADING: 'Identity Verification Needs Action',
  VERIFICATION_IDENTITY_REQUIRES_ACTION: `Looks like there were some issues while trying to verify your identity. Please try again.`,
  VERIFICATION_IDENTITY_GRACE_PERIOD_WARNING_HEADING: 'Identity Reverification Required',
  VERIFICATION_IDENTITY_GRACE_PERIOD_WARNING:
    "The identity associated with your account will expire soon and requires action. Please complete [Stripe's identity verification]({learnMoreUrl}) to maintain your apps' current verification statuses.",
  VERIFICATION_INSECURELY_STORING_MESSAGE_DATA_ERROR: `If you store message content off-platform, you must automatically delete message content after 30 days of storage, and encrypt messages at rest.`,
  VERIFICATION_APPLICATION_DESCRIPTION_HEADING: 'Application Details',
  VERIFICATION_APPLICATION_DESCRIPTION_SUBHEADING:
    'What does your application do? Please be as detailed as possible, and feel free to include links to image or video examples.',
  VERIFICATION_DATA_COLLECTION_HEADING: 'Data Collection',
  VERIFICATION_DATA_COLLECTION_SUBHEADING: 'Tell us more about the data you store and process from Discord.',
  VERIFICATION_DATA_COLLECTION_DATA_STORED_LABEL: 'What Discord data do you store?',
  VERIFICATION_DATA_COLLECTION_DATA_STORED_PLACEHOLDER: 'i.e User IDs, Server IDs, message content, etc.',
  VERIFICATION_DATA_COLLECTION_MESSAGES_STORED_LABEL: 'Do you store message content?',
  VERIFICATION_DATA_COLLECTION_MESSAGES_STORED_FOLLOWUP:
    'If you store message content off-platform, you must comply with the following asks:',
  VERIFICATION_DATA_COLLECTION_MESSAGES_STORED_AUTODELETE:
    'Do you automatically delete message content after 30 days of storage?',
  VERIFICATION_DATA_COLLECTION_MESSAGES_STORED_ENCRYPTION: 'Do you encrypt message content at rest?',

  VERIFICATION_DATA_COLLECTION_DATA_PURPOSES_LABEL: 'For what purpose(s) do you store the information you collect?',
  VERIFICATION_DATA_COLLECTION_DATA_PURPOSES_PLACEHOLDER:
    'Any features requiring data storage, i.e leaderboards, backups, etc.',
  VERIFICATION_DATA_COLLECTION_DATA_RETENTION_LABEL: 'For how long do you store it?',
  VERIFICATION_DATA_COLLECTION_DATA_RETENTION_PLACEHOLDER: `Please clarify how long you keep the information you're collecting.`,
  VERIFICATION_DATA_COLLECTION_DATA_DELETION_LABEL: 'What is the process for users to request deletion of their data?',
  VERIFICATION_DATA_COLLECTION_DATA_DELETION_PLACEHOLDER:
    'A deletion process for any collected Discord user or server data is required. Please describe yours.',
  VERIFICATION_INFRASTRUCTURE_HEADING: 'Infrastructure',
  VERIFICATION_INFRASTRUCTURE_SUBHEADING: `Tell us more about your application's infrastructure and your team's security practices.`,
  VERIFICATION_INFRASTRUCTURE_HOST_LABEL: 'How do you host your bot?',
  VERIFICATION_INFRASTRUCTURE_HOST_DESCRIPTION_PLACEHOLDER: `Please provide the URL of your VPS/VDS provider, if using one, or a description of your computer setup if you're hosting your bot at home.`,
  VERIFICATION_INFRASTRUCTURE_LIBRARY_LABEL: 'What language or library was your bot written with?',
  VERIFICATION_INFRASTRUCTURE_LIBRARY_DESCRIPTION_PLACEHOLDER: `Please describe how you wrote your bot.`,
  VERIFICATION_INFRASTRUCTURE_SECURITY_LABEL: 'How do you keep your bot secure?',
  VERIFICATION_INFRASTRUCTURE_SECURITY_PLACEHOLDER:
    'Please provide a description of your security protocol, including information on how you secure your host setup and code base, along with information on how you secure your Discord account.',
  VERIFICATION_INFRASTRUCTURE_VULNERABILITY_DISCLOSURE_LABEL:
    'How can users contact you with security concerns and other questions regarding your bot?',
  VERIFICATION_INFRASTRUCTURE_VULNERABILITY_DISCLOSURE_PLACEHOLDER:
    'Providing a means of contact for a verified bot is required, be it through a dedicated command, via Discord DMs or in a support server, or other means.',
  VERIFICATION_INTENTS_REQUESTED_INTENTS_LABEL:
    'Which intents are you applying for, if any? (Leave blank if you do not need any of these)',
  VERIFICATION_INTENTS_USE_CASE_LABEL:
    'For each Privileged Intent that you have selected, please explain your use case (why you need this data).',
  VERIFICATION_INTENTS_USE_CASE_PLACEHOLDER: `Please provide a detailed description of any features in your bot that require the privileged intents you're requesting.`,
  VERIFICATION_INTENTS_USE_CASE_SUPPLEMENTAL_MATERIAL_LABEL:
    'For each Privileged Intent that you have selected, please provide links to screenshots and/or videos that demonstrate your use case.',
  VERIFICATION_INTENTS_USE_CASE_SUPPLEMENTAL_MATERIAL_PLACEHOLDER: `Please note that we require a demonstration of your features working within a Discord server. Note that any bot in less than 75 servers can use intents without restriction, so you can feel free to test that command on a smaller version of your bot for demonstration purposes.`,
  VERIFICATION_SUBMIT: 'Submit',
  VERIFICATION_ERROR_CONSENT_DECLINED:
    'We are unable to verify your identity because you did not give Stripe permission to verify your identity.',
  VERIFICATION_ERROR_UNVERIFIED:
    'We are unable to verify your identity because one or more of the documents you provided are unverified. Please try again.',
  VERIFICATION_ERROR_DEVICE_UNSUPPORTED:
    'We are unable to verify your identity because the current device you are using is unsupported. Please try again on a supported device.',
  VERIFICATION_ERROR_VERIFICATION_DOCUMENT_EXPIRED:
    'We are unable to verify your identity because one or more of the documents you provided are expired. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_DOCUMENT_INVALID:
    'We are unable to verify your identity because one or more of the documents you provided are invalid. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_UNEXPECTED_DOCUMENT_COUNTRY:
    'We are unable to verify your identity because one or more of the documents you provided had an unexpected issuing country. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_UNEXPECTED_DOCUMENT_TYPE:
    'We are unable to verify your identity because one or more of the documents you provided had an unexpected document type. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_NOT_READABLE:
    'We are unable to verify your identity because one or more of the documents you provided were not readable. It may have been too blurry or not well lit. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_MISSING_BACK:
    'We are unable to verify your identity because the back of one or more of the documents you provided were missing. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_ID_TYPE_NOT_SUPPORTED:
    'We are unable to verify your identity because one or more of the documents you provided are not supported. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_CORRUPT:
    'We are unable to verify your identity because one or more of the documents you provided are invalid/corrupted. Please try again.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_FAILED_COPY:
    'We are unable to verify your identity because one or more of the documents you provided are a copy of an original document. Please try again with the original document.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_MANIPULATED_DOCUMENT:
    'We are unable to verify your identity because one or more of the documents you provided have been altered or damaged. Please try again with the original document.',
  VERIFICATION_ERROR_VERIFICATION_SCAN_FAILED_GRAYSCALE:
    'We are unable to verify your identity because one or more of the documents you provided was uploaded in grayscale. Please try again with the original document.',
  VERIFICATION_ERROR_VERIFICATION_UNDER_SUPPORTED_AGE:
    'We are unable to verify your identity because you are under the minimum supported age for your country. Please try again with help from a parent, legal guardian, or other trusted sponsor.',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_SETTINGS_HEADING: 'Activity Settings',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_WARNING_ENABLE_ACTIVITIES: 'Missing Requirement: $[URL Mapping](url)',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_SETTINGS_SUBHEADING: 'A place for you to configure your activity settings',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_ENABLED_ACTIVITIES: 'Activities are enabled',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_DISABLED_ACTIVITIES: 'Activities are disabled',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_ENABLE_ACTIVITIES_HEADING: 'Enable Activities',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_ENABLE_ACTIVITIES_SUBHEADING:
    "Enable users to open your app's Activity from all activity surfaces.",
  EMBEDDED_APPLICATION_CUSTOM_LINKS_HEADING: 'Custom Links',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_SUBHEADING: 'Create and modify custom links for your activity',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_EMPTY: 'You don’t have any custom links yet, sad face.',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_EMPTY_SECONDARY: `Click Create New to get started.`,
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_ID: 'ID',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_TITLE: 'Title',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_DESC: 'Description',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_IMAGE: 'Image',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_ACTIONS: 'Actions',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_ACTION_COPY: 'Copy Link',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_TABLE_ACTION_EDIT: 'Edit',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_HEADING: 'Custom Link',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_IMAGE_DESC:
    'Upload a PNG, JPG, or GIF under 2MB. Images should be at least 344x122 with a 1.79 ratio.',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_LABEL_IMAGE: 'Image',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_LABEL_TITLE: 'Title',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_LABEL_DESCRIPTION: 'Description',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_LABEL_CUSTOM_ID: 'Custom ID',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_CREATE: 'Create',
  EMBEDDED_APPLICATION_CUSTOM_LINK_MODAL_SAVE: 'Save',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_CREATE_BUTTON: 'Create New',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_DELETE_TITLE: 'Delete',
  EMBEDDED_APPLICATION_CUSTOM_LINKS_DELETE_DESC:
    'Are you sure? Deleting your custom link is immediate and irreversible.',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_URL_MAPPINGS_HEADING: 'Activity URL Mappings',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_URL_MAPPINGS_SUBHEADING:
    'A place for you to configure your activity URL mappings',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_ASSETS_HEADING: 'Activity Assets',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_ASSETS_SUBHEADING:
    'Preview and update your assets here! Please note that updates may be delayed due to caching, so be patient.',
  EMBEDDED_APPLICATION_EMBEDDED_APPLICATION_ASSETS_ERROR:
    'An error occured while loading your assets. Please try again.',
  EMBEDDED_APPLICATION_EMBEDDED_BACKGROUND_HEADING: 'Background',
  EMBEDDED_APPLICATION_EMBEDDED_BACKGROUND_SUBHEADING:
    'Used as a background overlay in Grid view. Artwork should be clustered around the edges of the image leaving space in the center of the image so the UI does not clash with it.',
  EMBEDDED_APPLICATION_EMBEDDED_BACKGROUND_SPECIFICATIONS: 'Specifications: 16:9 Ratio and at least 1024 pixels wide.',
  EMBEDDED_APPLICATION_COVER_ART_HEADING: 'Cover Art',
  EMBEDDED_APPLICATION_COVER_ART_SUBHEADING:
    'Used as the main image on the Activity Shelf. It is suggested that this image contain the title and some art in the background.',
  EMBEDDED_APPLICATION_COVER_ART_SPECIFICATIONS: 'Specifications: 16:9 Ratio and at least 1024 pixels wide.',
  EMBEDDED_APPLICATION_VIDEO_PREVIEW_HEADING: 'Video Preview',
  EMBEDDED_APPLICATION_VIDEO_PREVIEW_SUBHEADING:
    'Shown when hovering on an activity in the menu. Also shown on the upsell when you click on an activity in the menu. Suggested to show a brief preview of the activity. Can be a screen recording of the activity being played.',
  EMBEDDED_APPLICATION_VIDEO_PREVIEW_SPECIFICATIONS:
    'Specifications: 10 seconds or less MP4 file with dimensions 640x360 pixels under 500KB.',
  EMBEDDED_APPLICATION_URL_MAPPINGS: 'URL Mappings',
  EMBEDDED_APPLICATION_URL_MAPPING_DOCUMENTATION_HERE:
    'For more information on URL Mapping, check out the documentation [here]({url}).',
  EMBEDDED_APPLICATION_ANALYTICS_MONETIZATION_ANALYTICS_HEADING: 'Monetization Analytics',
  EMBEDDED_APPLICATION_ANALYTICS_MONETIZATION_ANALYTICS_SUBHEADING:
    'Note: Currently analytics includes subscription data only (see CSV download below)',
  EMBEDDED_APPLICATION_ANALYTICS_MONETIZATION_ANALYTICS_PANEL_TOTAL_GROSS_MERCHANDISE: 'Total Gross Merchandise Value',
  EMBEDDED_APPLICATION_ANALYTICS_MONETIZATION_ANALYTICS_PANEL_TOTAL_PAYOUT: 'Total Payout',
  EMBEDDED_APPLICATION_ANALYTICS_MONETIZATION_AGGREGATED_SKU_ANALYTICS_HEADING: 'Aggregated SKU Analytics',
  EMBEDDED_APPLICATION_ANALYTICS_MONETIZATION_AGGREGATED_SKU_ANALYTICS_SUBHEADING:
    'Download a packaged CSV of all your SKUs for a given month (includes all purchase types)',
  EMBEDDED_APPLICATION_ANALYTICS_PURCHASE_DATA_HEADING: 'Purchase Data',
  EMBEDDED_APPLICATION_ANALYTICS_SUBSCRIPTION_DATA_HEADING: 'Subscription Data',
  EMBEDDED_APPLICATION_ROOT_MAPPING: 'Root Mapping',
  EMBEDDED_APPLICATION_ROOT_MAPPING_REQUIRED: 'Error: Root URL Mapping Target is required!',
  EMBEDDED_APPLICATION_PREFIX: 'Prefix',
  EMBEDDED_APPLICATION_TARGET: 'Target',
  EMBEDDED_APPLICATION_ADD_ANOTHER: 'Add Another URL Mapping',
  EMBEDDED_APPLICATION_PREVIEW_VIDEO_ASSET_ID: 'Preview Video Asset ID',
  EMBEDDED_APPLICATION_PHONE_DEFAULT_ORIENTATION_LOCK_STATE: 'Phone Default Orientation Lock State',
  EMBEDDED_APPLICATION_TABLET_DEFAULT_ORIENTATION_LOCK_STATE: 'Tablet Default Orientation Lock State',
  EMBEDDED_APPLICATION_PHONE_DEFAULT_ORIENTATION_LOCK_STATE_NOTES:
    "This setting is only consumed in the Discord mobile apps on phones. Desktop / Web Browsers are always sized based on the app window's size.",
  EMBEDDED_APPLICATION_TABLET_DEFAULT_ORIENTATION_LOCK_STATE_NOTES:
    'This setting is only consumed in the Discord mobile apps on tablets.',
  EMBEDDED_APPLICATION_ORIENTATION_LOCK_STATE_UNLOCKED: 'Unlocked',
  EMBEDDED_APPLICATION_ORIENTATION_LOCK_STATE_PORTRAIT: 'Portrait',
  EMBEDDED_APPLICATION_ORIENTATION_LOCK_STATE_LANDSCAPE: 'Landscape',
  EMBEDDED_APPLICATION_AGE_GATE: 'Age Gate',
  EMBEDDED_APPLICATION_AGE_GATED: 'Age Gated',
  EMBEDDED_APPLICATION_AGE_GATE_NOTES:
    'Applications with content unsuitable for children under the age of 18 should be marked as Age Gated',
  EMBEDDED_APPLICATION_RESPONSIVE_ASPECT_RATIO_TOGGLE: 'Use responsive aspect ratio',
  EMBEDDED_APPLICATION_RESPONSIVE_ASPECT_RATIO_TOGGLE_NOTES:
    'On December 1, 2024, this setting will be retired, and all activities will default to a dynamic aspect ratio.',
  EMBEDDED_APPLICATION_SUPPORTED_PLATFORMS: 'Supported Platforms',
  EMBEDDED_APPLICATION_SUPPORTED_PLATFORM_WEB: 'Web',
  EMBEDDED_APPLICATION_SUPPORTED_PLATFORM_IOS: 'iOS',
  EMBEDDED_APPLICATION_SUPPORTED_PLATFORM_ANDROID: 'Android',
  EMBEDDED_APPLICATION_PREVIEW: 'PREVIEW',
  EMBEDDED_APPLICATION_JOIN_ACTIVITY: 'Join Activity',
  EMBEDDED_APPLICATION_PARTICIPANTS_LABEL: 'Up to {count} participants',
  EMBEDDED_APPLICATION_UNLIMITED_PARTICIPANTS: 'Unlimited participants',
  EMBEDDED_APPLICATION_VIDEO: 'Video',
  EMBEDDED_APPLICATION_GETTING_STARTED_TITLE: 'Get Started with Activities',
  EMBEDDED_APPLICATION_GETTING_STARTED_SUBTITLE: 'Build rich experiences directly inside Discord.  [Learn more]({url})',
  EMBEDDED_APPLICATION_GETTING_STARTED_BULLET_ONE_TITLE: 'Get started quickly',
  EMBEDDED_APPLICATION_GETTING_STARTED_BULLET_ONE_BODY:
    'Download the SDK, follow our [Getting Started]({url}) guide, and say “Hello, World!”',
  EMBEDDED_APPLICATION_GETTING_STARTED_BULLET_TWO_TITLE: 'Build and test together',
  EMBEDDED_APPLICATION_GETTING_STARTED_BULLET_TWO_BODY:
    'Invite teammates and private testers to build with you. Work together to make something great!',
  EMBEDDED_APPLICATION_GETTING_STARTED_BULLET_THREE_TITLE: 'Distribute and earn',
  EMBEDDED_APPLICATION_GETTING_STARTED_BULLET_THREE_BODY:
    'Make your app discoverable, easily monetize with integrated payments, and distribute on Discord.',
  EMBEDDED_APPLICATION_GETTING_STARTED_WARNING:
    'Activities are currently in developer preview. [Learn more]({url}) about what’s available.',
  EMBEDDED_APPLICATION_VERIFIED_APPS_CANNOT_ENABLE_ACTIVITIES: 'Verified apps cannot enable activities at this time.',
  EMBEDDED_APPLICATION_GETTING_STARTED_COMING_SOON_TAG: 'Coming Soon',
  EMBEDDED_APPLICATION_GETTING_STARTED_ACKNOWLEDGE_BUTTON: 'Enable',
  EMBEDDED_APPLICATION_UNEMBED_HEADING: 'Disable Activities',
  EMBEDDED_APPLICATION_UNEMBED_SUBHEADING: `Changed your mind? Remove activity functionality from your app.`,
  EMBEDDED_APPLICATION_UNEMBED_BUTTON: 'Remove',

  EMBEDDED_APPLICATION_ENABLE_MODAL_TITLE: 'Enable Activities?',
  EMBEDDED_APPLICATION_ENABLE_MODAL_MODAL_CONTENT_ONE:
    'Enabling activities will automatically create an Entry Point command for your application.',
  EMBEDDED_APPLICATION_ENABLE_MODAL_MODAL_CONTENT_TWO: `An Entry Point command serves as the primary way for users to open an app's Activity from the App Launcher and Voice Channels.`,
  EMBEDDED_APPLICATION_ENABLE_MODAL_MODAL_CONTENT_THREE: 'Read more about [Entry Points in our documentation]({url}).',
  EMBEDDED_APPLICATION_ENABLE_MODAL_ERROR: 'Error enabling activities.',

  DISCORD_SOCIAL_SDK_TELL_US_ABOUT_GAME: 'Tell us a bit about your game',
  DISCORD_SOCIAL_SDK_ENTER_DETAILS_FOR_SDK_ACCESS: `To get instant access to the SDK downloads and more information, please enter the following details`,
  DISCORD_SOCIAL_SDK_DETAILS_LABEL_NAME: 'Name',
  DISCORD_SOCIAL_SDK_DETAILS_LABEL_BUSINESS_EMAIL: 'Business email',
  DISCORD_SOCIAL_SDK_DETAILS_LABEL_COMPANY_NAME: 'Company name',
  DISCORD_SOCIAL_SDK_DETAILS_LABEL_COMPANY_WEBSITE: 'Company website',
  DISCORD_SOCIAL_SDK_DETAILS_SUBMIT_AGREE_TO_TERMS:
    'By clicking Submit, you agree to the [Discord Social SDK Terms]({url}) and to receiving emails from Discord about the Social SDK.',
  DISCORD_SOCIAL_SDK_RESOURCES: 'Social SDK Resources',
  DISCORD_SOCIAL_SDK_RESOURCES_API_DOCUMENTATION: 'API Documentation',
  DISCORD_SOCIAL_SDK_RESOURCES_DESIGN_GUIDELINES: 'Design Guidelines',
  DISCORD_SOCIAL_SDK_RESOURCES_DOWNLOADS: 'Downloads',
  DISCORD_SOCIAL_SDK_RESOURCES_INFO_SUBMITTED: 'Your info has been submitted.',

  DISCORD_SOCIAL_SDK_GET_STARTED_TITLE: 'Get started with the Discord Social SDK',
  DISCORD_SOCIAL_SDK_GET_STARTED_HEADER: `Power your game's social layer with Discord. Talk a bit about the value prop and what the SDK is. You must first meet our eligibility requirements before proceeding to downloads.`,
  DISCORD_SOCIAL_SDK_REQUIREMENTS: 'Requirements',
  DISCORD_SOCIAL_SDK_APP_MUST_BELONG_TO_TEAM: 'Your application must belong to a $[Developer Team](link).',
  DISCORD_SOCIAL_SDK_TEAM_OWNER_MUST_BE_18: 'The team owner of this application must be at least 18 years old.',
  DISCORD_SOCIAL_SDK_ALL_MEMBERS_MUST_BE_VERIFIED:
    'All members of your developer team must have a verified email and two-factor authentication.',
  DISCORD_SOCIAL_SDK_MUST_NOT_CONTAIN_BAD_LANGUAGE:
    'Your app must not contain any harmful or bad language in its name, description, commands, or role connection metadata.',
  DISCORD_SOCIAL_SDK_MUST_NOT_HAVE_ANY_SAFETY_FLAGS: 'Your app must not be quarantined or have any other safety flags.',

  DISCORD_SOCIAL_SDK_GETTING_STARTED_HEADING: 'Getting Started',
  DISCORD_SOCIAL_SDK_SUCCESS_HEADING: 'Your app is enabled',
  DISCORD_SOCIAL_SDK_SUCCESS_DESCRIPTION: 'Get started with the Discord Social SDK immediately.',
  DISCORD_SOCIAL_SDK_SUCCESS_DISMISS: "Let's go",
  DISCORD_SOCIAL_SDK_GETTING_STARTED_DESCRIPTION:
    'With the Discord Social SDK, players can connect with friends, share gameplay, and jump into your game with ease. Seamless Discord-powered integration means effortless cross-platform communications, voice chat, and other powerful social tools that can drive engagement and expand your player base.',
  DISCORD_SOCIAL_SDK_GETTING_STARTED_INTERESTED_IN_BETA:
    'Interested in some of our additional closed beta features for the SDK? [Apply here]({url}).',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_HEADING: 'External Auth',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_SUBHEADING:
    'Configure identity providers used to [authenticate provisional accounts]({url}).',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_NUM: '{count, number} External Auth Providers',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_ADD_PROVIDER: 'Add Auth Provider',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_MODAL_ADD_PROVIDER: 'Add an external auth provider',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_MODAL_ADDED_PROVIDERS: 'Added Auth Providers',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_EDIT_PROVIDER: 'Edit {provider}',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_PROVIDER: 'Provider',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_TYPE: 'Type',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_STEAM_APP_CLIENT_ID: 'Steam App ID',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_UNITY_PROJECT_ID: 'Unity Project ID',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_CLIENT_ID: 'Client ID',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_ISSUER_URL: 'OpenID Connect Issuer URL',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_DELETE_PROVIDER: 'Delete {provider}',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_DELETE_PROVIDER_CONFIRMATION:
    'Provisional users who currently use this identity provider will no longer be able to authorize. Are you sure you want to remove {provider} as an external auth provider?',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_EOS_CLIENT_ID_SUBLABEL:
    'Client ID used to authenticate the user with [EOS Connect ID tokens]({eosIdTokenLink}), [EAS ID tokens]({easIdTokenLink}), or [EAS access tokens]({easAccessTokenLink}).',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_OIDC_URL_SUBLABEL:
    'The full URL to your OpenID Connect configuration document must follow this format:',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_UNITY_PROJECT_ID_SUBLABEL:
    'Unity project ID used when authenticating a user with [Unity Services ID tokens]({unityIdTokenLink}).',
  DISCORD_SOCIAL_SDK_EXT_AUTH_PROVIDERS_OIDC_URL_SUBLABEL_URL_FORMAT: `https://<domain>{suffix}`,
  DISCORD_SOCIAL_SDK_DOWNLOADS_HEADING: 'Downloads',
  DISCORD_SOCIAL_SDK_DOWNLOADS_PICK_YOUR_VERSION: 'Pick your version',
  DISCORD_SOCIAL_SDK_LOOKING_FOR_CONSOLE: 'Looking for console downloads?',
  DISCORD_SOCIAL_SDK_LOOKING_FOR_CONSOLE_SUBTEXT:
    'For access to console-specific SDKs, please [verify with your console platform provider]({url}).',
  DISCORD_SOCIAL_SDK_LATEST_VERSION: '(latest)',
  DISCORD_SOCIAL_SDK_DOWNLOAD_YOUR_BUILDS: 'Download Version {version}',
  DISCORD_SOCIAL_SDK_NO_DOWNLOADS_AVAILABLE: 'No downloads available',
  DISCORD_SOCIAL_SDK_RELEASED_DATE: 'Released {releasedAt, date, medium}',

  DEVELOPER_EXPERIENCE_SURVEY_SURVEY_HEADING: 'Survey',
  DEVELOPER_EXPERIENCE_SURVEY_SURVEY_PITCH_VOTE:
    'Play and vote for your favorite Discord App Pitches in the Town Hall server through through July 11!',
  DEVELOPER_EXPERIENCE_SURVEY_SURVEY_PITCH_VOTE_CTA: 'Join Now',
  DEVELOPER_EXPERIENCE_SURVEY_CSAT_SURVEY_PITCH: 'How satisfied are you with developing on Discord?',
  DEVELOPER_EXPERIENCE_SURVEY_VERY_UNSATISFIED: 'Very unsatisfied',
  DEVELOPER_EXPERIENCE_SURVEY_UNSATISFIED: 'Unsatisfied',
  DEVELOPER_EXPERIENCE_SURVEY_NEUTRAL: 'Neutral',
  DEVELOPER_EXPERIENCE_SURVEY_SATISFIED: 'Satisfied',
  DEVELOPER_EXPERIENCE_SURVEY_VERY_SATISFIED: 'Very satisfied',
  DEVELOPER_EXPERIENCE_SURVEY_VERY_UNSATISFIED_OPTION: '1',
  DEVELOPER_EXPERIENCE_SURVEY_UNSATISFIED_OPTION: '2',
  DEVELOPER_EXPERIENCE_SURVEY_NEUTRAL_OPTION: '3',
  DEVELOPER_EXPERIENCE_SURVEY_SATISFIED_OPTION: '4',
  DEVELOPER_EXPERIENCE_SURVEY_VERY_SATISFIED_OPTION: '5',
  DEVELOPER_EXPERIENCE_SURVEY_DISMISS: 'Dismiss',

  WINTER_SNOWFLAKES_CONTROL_DECORATIONS: 'Control Decorations',
  WINTER_SNOWFLAKES_CONTROLS: 'Snowflake Controls',
  WINTER_SNOWFLAKES_COUNT: 'Snowflake Count',
  WINTER_SNOWFLAKES_SHOW: 'Show Snowflakes',
  WINTER_SNOWFLAKES_SHOW_USER_ID: 'Show User ID Snowflake',

  EMBEDS_TITLE: 'Embed Debugger',
  EMBEDS_SUBTITLE: 'Test and debug link embeds for your website',
  EMBEDS_DESCRIPTION:
    'Discord supports [oEmbed]({oEmbedLink}), [Open Graph]({opengraphLink}), and [Twitter Card]({twitterTagsLink}) metadata formats for rendering link embeds.',
  EMBEDS_LABEL: 'Website URL',
  EMBEDS_SUBMIT: 'Generate Embed',
  EMBEDS_ERROR: 'There was an error. Please try again later',

  ONBOARDING_BLOCKED_TITLE: 'Your app is not eligible for monetization',
  ONBOARDING_BLOCKED_BODY: 'Please reach out to [developer support]({link}) to understand more',
  ONBOARDING_EDUCATION_TITLE: 'Monetize Your App',
  ONBOARDING_EDUCATION_SUBTITLE: 'Earn money with integrated premium apps offerings. $[Learn more](link)',
  ONBOARDING_EDUCATION_BULLET_ONE_TITLE: 'Fulfill eligibility requirements ',
  ONBOARDING_EDUCATION_BULLET_ONE_BODY:
    'Run through our quick checklist, and make sure you’re ready to start monetizing your app.',
  ONBOARDING_EDUCATION_BULLET_TWO_TITLE: 'Set up and integrate ',
  ONBOARDING_EDUCATION_BULLET_TWO_BODY:
    'Create your offering, customize it to your liking, and integrate our API to get ready for launch.',
  ONBOARDING_EDUCATION_BULLET_THREE_TITLE: 'Start earning',
  ONBOARDING_EDUCATION_BULLET_THREE_BODY:
    'Go live and get paid! To learn more about our payouts process visit our $[help center.](link)',
  ONBOARDING_EDUCATION_BUTTON: 'Get Started',
  ONBOARDING_ERROR_FETCHING_APPLICATION: 'There was an error fetching this application. Please try again later',
  ONBOARDING_PROGRESS_GETTING_STARTED: 'Getting Started',
  ONBOARDING_PROGRESS_ELIGIBILITY_REQUIREMENTS: 'Eligibility Requirements',
  ONBOARDING_PROGRESS_SET_UP_SKUS: 'Set Up SKUs',
  ONBOARDING_TITLE: 'App Monetization',
  ONBOARDING_SUBTITLE: 'Offer premium experiences to people who love your app, and start earning!',
  ONBOARDING_ELIGIBLE: "You're eligible for monetization!",
  ONBOARDING_INELIGIBLE: 'Complete these steps to enable monetization!',
  ONBOARDING_REQUIREMENT_VERIFIED: 'Your app must be verified',
  ONBOARDING_REQUIREMENT_TEAM: 'Your app must belong to a $[Developer Team](link)',
  ONBOARDING_REQUIREMENT_TERMS_OF_SERVICE: 'Your app must have a link to $[Terms of Service](link)',
  ONBOARDING_REQUIREMENT_PRIVACY_POLICY: 'Your app must have a link to your $[Privacy Policy](link)',
  ONBOARDING_REQUIREMENT_SAFE_NAMES:
    'Your app must not contain any harmful or bad language in its name, description, commands, or role connection metadata',
  ONBOARDING_REQUIREMENT_QUARANTINE: 'Your app must not be quarantined',
  ONBOARDING_REQUIREMENT_VALID_PAYOUT_LOCALE:
    'You must have payouts set up with a valid payment method in an [eligible country]({link})',
  ONBOARDING_REQUIREMENT_VALID_PAYOUT_STATUS: 'Your payout account must be active',
  ONBOARDING_REQUIREMENT_USER_AGE_SUPPORTED: 'The team owner must be at least 18 years old',
  ONBOARDING_REQUIREMENT_EMAIL_2FA: 'All members of your developer team must have a verified email and 2FA set up',
  ONBOARDING_ELIGIBLE_DETAILS:
    'To get started please read and agree to our [Monetization Terms]({monetizationTermsUrl}) & [Discord Premium Apps Policy]({premiumAppsPolicyUrl}).',
  ONBOARDING_AGREE: 'Agree',
  ONBOARDING_ACTION_SET_UP_PAYOUTS: 'Set up Payouts',
  ONBOARDING_ACTION_SET_UP_2FA: 'Set up 2FA',
  ONBOARDING_ACTION_SET_UP_DATE_OF_BIRTH: 'Verify Date of Birth',
  ONBOARDING_MUST_BE_TEAM_OWNER_WARNING: 'You must be the team owner to move forward with monetization onboarding',
  ONBOARDING_APP_HAS_SKUS:
    'To manage existing SKUs, you must re-enable monetization for your app by completing the monetization onboarding below. If you have any trouble or questions, you can reach out to our [developer support team]({developerSupportUrl}).',
  ONBOARDING_EMBEDDED_APPS_WARNING: 'Apps which have opted into being EMBEDDED cannot set up monetization at this time',

  VERIFICATION_ONBOARDING_HEADING: 'Verify your App',
  VERIFICATION_ONBOARDING_SUBHEADING:
    'In order to scale your application past 100 servers, we require your team owner to complete identity and application verification. [Learn more]({url}).',
  VERIFICATION_ONBOARDING_CHECKLIST_TITLE: 'Verification Qualifications',
  VERIFICATION_ONBOARDING_CHECKLIST_SUBTITLE_INCOMPLETE:
    'Your app is missing {numberTodo} {numberTodo, plural, one {criterion} other {criteria}} and cannot be verified',
  VERIFICATION_ONBOARDING_APP_INTENTS_TITLE: 'App Intents',
  VERIFICATION_ONBOARDING_CHECKLIST_SUBTITLE_COMPLETE: 'Verification qualifications complete',
  VERIFICATION_ONBOARDING_APP_INTENTS_INCOMPLETE:
    "You have {nUnverifiedIntents} unapproved {nUnverifiedIntents, plural, one {intent} other {intents}} and cannot verify your app until {nUnverifiedIntents, plural, one {it is} other {they are}} either approved or removed.\n\nIf you don't absolutely need these intents, we recommend removing them from your app.",
  VERIFICATION_ONBOARDING_APP_INTENTS_COMPLETE: 'All of your requested intents have been approved',
  VERIFICATION_ONBOARDING_UNAPPROVED_INTENTS_WARNING:
    'Your app is temporarily approved for Intents. You may continue to use Privileged Intents until your app joins 100 servers. At that point, you must either apply for full access or turn them off $[here](here), or your app will not be able to join more servers. You may apply for full access when your app reaches 75 servers.',
  VERIFICATION_ONBOARDING_UNAPPROVED_INTENTS_ERROR:
    'Your app is temporarily approved for Intents and has been limited to joining 100 servers. To enable joining additional servers you must either apply for full access or turn them off $[here](here), or your app will not be able to join more servers.',
  VERIFICATION_ONBOARDING_REQUIREMENT_HAS_TEAM: 'Your app must belong to a Team',
  VERIFICATION_ONBOARDING_REQUIREMENT_HAS_SAFE_NAMES:
    'Your app must not contain any harmful or bad language in its name, description, commands, or role connection metadata',
  VERIFICATION_ONBOARDING_REQUIREMENT_TERMS_OF_SERVICE: 'Your app must have a link to Terms of Service',
  VERIFICATION_ONBOARDING_REQUIREMENT_PRIVACY_POLICY: 'Your app must have a link to your Privacy Policy',
  VERIFICATION_ONBOARDING_REQUIREMENT_INSTALL_LINK: 'Your app must have an install link',
  VERIFICATION_ONBOARDING_REQUIREMENT_APPROVED_PRESENCE_INTENT: 'Presence Intent must be approved',
  VERIFICATION_ONBOARDING_REQUIREMENT_APPROVED_SERVER_MEMBERS_INTENT: 'Server Members Intent must be approved',
  VERIFICATION_ONBOARDING_REQUIREMENT_APPROVED_MESSAGE_CONTENT_INTENT: 'Message Content Intent must be approved',
  VERIFICATION_ONBOARDING_REQUIREMENT_TEAM_OWNER_VERIFIED: 'Team owner must complete Identity Verification',
  VERIFICATION_ONBOARDING_REQUIREMENT_EMAIL_2FA:
    'All members of your developer team must have a verified email and 2FA set up',
  VERIFICATION_ONBOARDING_ALERT_CANNOT_SUBMIT_FOR_VERIFICATION:
    'Your app cannot request approval for intent verification until it meets the Verification Qualifications listed above.',
  VERIFICATION_ONBOARDING_APP_IDENTITY_HEADER: 'App Identity',
  VERIFICATION_ONBOARDING_CAUTION: 'Caution',
  VERIFICATION_ONBOARDING_CAUTION_VERIFICATION_WARNING:
    "After verification, you cannot modify the app's name or transfer ownership without the assistance of Discord's support team.",
  VERIFICATION_ONBOARDING_APP_NAME: 'APP NAME',
  VERIFICATION_ONBOARDING_EDIT_NAME: 'Edit Name',
  VERIFICATION_ONBOARDING_OWNERSHIP: 'OWNERSHIP',
  VERIFICATION_ONBOARDING_CHANGE_OWNER: 'Change Owner',
  VERIFICATION_ONBOARDING_AFFIRM_TOS_AND_DEVELOPER_POLICY:
    'I affirm that my application abides by the Discord [Developer Terms of Service]({tosUrl}) and [Developer Policy]({devPolicyUrl})',
  VERIFICATION_ONBOARDING_AFFIRM_LOCKED_OWNER_AND_NAME:
    "I am the owner of this app. I recognize that after verification, I cannot modify the app's name or transfer ownership without the assistance of Discord’s support team",
  VERIFICATION_ONBOARDING_VERIFY_APP: 'Verify App',
  VERIFICATION_ONBOARDING_WARNING_MUST_BE_TEAM_OWNER: 'You must be the team owner to verify this app',
  VERIFICATION_ONBOARDING_BLOCKED_TITLE: 'Your app is not eligible for verification',
  VERIFICATION_ONBOARDING_BLOCKED_BODY: 'Please reach out to [developer support]({link}) to understand more',
  VERIFICATION_ONBOARDING_ERROR_UNKNOWN: 'Unknown Verification Error',
  VERIFICATION_ONBOARDING_CONFIRM_VERIFICATION: 'Confirm Verification',
  VERIFICATION_ONBOARDING_CONFIRM_VERIFICATION_DETAILS:
    'Some app settings cannot be changed without approval after getting Verified. Make sure your app works as expected with your current settings before continuing.',
  VERIFICATION_ONBOARDING_CONFIRM_VERIFICATION_CANNOT_BE_UNDONE: 'This action cannot be undone.',

  MFA_PICKER_HEADER: 'Multi-Factor Authentication',
  MFA_V2_BACKUP_NAME: 'Use a backup code',
  MFA_V2_PASSWORD_NAME: 'Use your password',
  MFA_V2_SMS_NAME: 'Use a code sent to your phone',
  MFA_V2_TOTP_NAME: 'Use your authenticator app',
  MFA_V2_WEBAUTHN_CTA: 'Authenticate with security key',
  MFA_V2_WEBAUTHN_GENERIC_ERROR: 'An error occurred. Please try again.',
  MFA_V2_WEBAUTHN_NAME: 'Use a security key',
  MFA_VERIFY_WITH_SOMETHING_ELSE: 'Verify with something else',
  MFA_TWO_FA_ENTER_SMS_TOKEN_SENDING: 'Sending...',
  MFA_TWO_FA_ENTER_SMS_TOKEN_SENT: `We've sent a message to !!{phoneNumber}!!.  Please enter the code you received.`,

  UPDATED_TERMS_OF_SERVICE_JUNE_2024_HEADING: 'Important',
  UPDATED_TERMS_OF_SERVICE_JUNE_2024_BODY:
    'We’re updating our Developer Terms of Service and Developer Policy, effective July 8, 2024. Please review.',
  UPDATED_TERMS_OF_SERVICE_JUNE_2024_CTA: 'See Terms',
  UPDATED_TERMS_OF_SERVICE_JUNE_2024_DISMISS: 'Dismiss',

  // Captcha
  GENERIC_CAPTCHA_HEADER: 'Wait! Are you human?',
  GENERIC_CAPTCHA_DESCRIPTION: 'Please confirm you’re not a robot.',

  // Campaign Builder
  CAMPAIGN_BUILDER_LOGIN_HEADER: 'Campaign Builder Login',
  CAMPAIGN_BUILDER_EMAIL_LABEL: 'Email',
  CAMPAIGN_BUILDER_EMAIL_PLACEHOLDER: 'Enter your Discord email',
  CAMPAIGN_BUILDER_PASSWORD_LABEL: 'Password',
  CAMPAIGN_BUILDER_PASSWORD_PLACEHOLDER: 'Enter your password',
  CAMPAIGN_BUILDER_MFA_LABEL: 'MFA Code (if enabled)',
  CAMPAIGN_BUILDER_MFA_PLACEHOLDER: 'Optional',
  CAMPAIGN_BUILDER_LOGIN_BUTTON: 'Login',
  CAMPAIGN_BUILDER_HEADER: 'Campaign Builder',
  CAMPAIGN_BUILDER_LOGOUT_BUTTON: 'Logout',
  CAMPAIGN_BUILDER_WELCOME_MESSAGE: 'Welcome to the Campaign Builder Panel!',
  CAMPAIGN_BUILDER_CAMPAIGNS_NOTICE: 'Your campaigns will appear here.',
  CAMPAIGN_BUILDER_LOADING: 'Loading...',
  CAMPAIGN_BUILDER_USER_MENU_LABEL: 'User menu',
});
